const idn = {
  login_title: 'Ingin bermain? Ayo ajak saya',
  login_facebook: 'Masuk dengan Facebook',
  login_line: 'Masuk dengan LINE',
  login_google: 'Masuk dengan Google',
  login_other: 'Metode Lain',
  login_phone: 'Masuk dengan Nomor Telepon',
  login_agree:
    'Masuk berarti Anda menyetujui Persyaratan dan Kebijakan Privasi dari nicee',
  login_smscode: 'Dapatkan Kode Verifikasi',
  login_now: 'Masuk Sekarang',
  home_index: 'Beranda',
  home_feed: 'Status',
  home_express_book: 'Janjian Kilat',
  home_message: 'Pesan',
  home_my: 'Saya',
  home_recommended: 'Rekomendasi',
  home_lol: 'League of Legends',
  home_duel: 'Arena of Valor',
  home_voice_chat: 'Pesan Suara',
  home_battle_canyon: 'Battle Canyon',
  home_pubg: 'PUBG',
  home_small_alarm: 'Alarm',
  home_rankings: 'Peringkat',
  home_top_players: 'Kumpulan Top Player',
  home_voice_room: 'Ruang Suara',
  home_input_nick: 'Silakan Masukkan Nama/ID/Skill',
  home_cancel: 'Batal',
  home_skill_names: 'Nama Skill',
  home_pull_more: 'Tarik ke bawah untuk memuat lebih banyak teman',
  home_release_more: 'Lepas untuk memuat lebih banyak teman',
  home_loading: 'Memuat',
  gamelol: 'League of Legends',
  gamelol_order_king: 'Pesan Raja',
  gamelol_rank_up: 'Wajib Naik Skor',
  gamelol_self_pic: 'Verifikasi Identitas',
  gamelol_filter: 'Filter',
  gamelol_week_star: 'Bintang Mingguan',
  gamelol_sort: 'Urutan',
  gamelol_synthesize_sort: 'Urutan Campur',
  gamelol_new_sort: 'Pendatang Baru',
  gamelol_high_sort: 'Harga Tertinggi',
  gamelol_low_sort: 'Harga Terendah',
  gamelol_gender: 'Jenis Kelamin',
  gamelol_female: 'Perempuan',
  gamelol_male: 'Laki-laki',
  gamelol_label: 'Label',
  gamelol_first_discount: 'Diskon Awal',
  gamelol_buzzworthy: 'Unggulan',
  gamelol_high_popular: 'Popularitas Tinggi',
  gamelol_high_new: 'Pemula Berkualitas',
  gamelol_7_minute: 'Coba 7 Menit',
  gamelol_expert_guiding: 'Panduan Ahli',
  gamelol_language_support: 'Teman Bicara',
  gamelol_tier: 'Tingkat',
  gamelol_elite: 'Elite',
  gamelol_grand_master: 'Grand Master',
  gamelol_master: 'Master',
  gamelol_diamond: 'Diamond',
  gamelol_platinum: 'Platinum',
  gamelol_expert_position: 'Keahlian Posisi',
  gamelol_top_lang: 'Top Lane',
  gamelol_jungle: 'Jungle',
  gamelol_mid_lang: 'Mid Lane',
  gamelol_adc: 'ADC',
  gamelol_support: 'Support',
  gamelol_price: 'Harga',
  gamelol_clear_filter: 'Hapus Filter',
  gamelol_complete: 'Selesai',
  gameduel: 'Arena of Valor',
  gameduel_week_star: 'Bintang Mingguan',
  gameduel_tier: 'Tier/Rank',
  gameduel_eternal_legend: 'Eternal Legend',
  gameduel_battlefield_legend: 'Battlefield Legend',
  gameduel_starlight: 'Starlight',
  gameduel_diamond: 'Diamond',
  gameduel_platinum: 'Platinum',
  gamevoice: 'Chatting Suara',
  gamevoice_week_star: 'Bintang Musik Mingguan',
  gamevoice_tier: 'Tingkat',
  gamevoice_mom_voice: 'Suara Ibu',
  gamevoice_queen_mom: 'Suara Ibu Elegan',
  gamevoice_queen_sister: 'Suara Kakak Elegan',
  gamevoice_queen_little: 'Suara Princess',
  gmaevoice_girl_little: 'Suara Gadis',
  gmaevoice_luoli_little: 'Suara Loli Muda',
  gamevoice_luoli: 'Suara Imut',
  gamevoice_shou: 'Suara Pasif',
  gamevoice_uncle: 'Suara Paman',
  gamevoice_youth: 'Suara Pemuda',
  gamevoice_youth_shou: 'Suara Pasif Pemuda',
  gamevoice_youth_uncle: 'Suara Paman Muda',
  gamevoice_live: 'Live Streamer',
  gamebattle: 'Battle Canyon',
  gamebattle_week_star: 'Bintang Mingguan Campur',
  gamebattle_tier: 'Tingkat',
  gamebattle_elite: 'Elite',
  gamebattle_grand_master: 'Master',
  gamebattle_master: 'Grand Master',
  gamebattle_diamond: 'Diamond',
  gamebattle_emerald: 'Jadeite',
  gamebattle_platinum: 'Platinum',
  gamehero: 'Valorant Gun Simulator',
  gamehero_tier: 'Tingkat',
  gamehero_soul: 'Radiant',
  gamehero_myth: 'Mitos',
  gamehero_diamond: 'Permata',
  gamehero_platinum: 'Platinum',
  gamehero_gold: 'Gold',
  gamehero_silver: 'Silver',
  gameapex: 'APEX',
  gameapex_tier: 'Tingkat',
  gameapex_hunter: 'Predator APEX',
  gameapex_master: 'Grand Master',
  gameapex_diamond: 'Diamond',
  gameapex_platinum: 'Platinum',
  gamenaraka: 'Naraka+',
  gamenaraka_tier: 'Tingkat',
  gamenaraka_abadi: 'Ashura Abadi',
  gamenaraka_bulan: 'Gerhana Bulan',
  gamenaraka_jatuh: 'Bintang Jatuh',
  gamenaraka_platinum: 'Platinum',
  all_skills: 'Semua Skill',
  normalskill: 'Biasa Skill',
  mbgame: 'Games Mobile',
  mbgame_duel: 'Legendary Showdown',
  mbgame_battle: 'League of Legends: Wild Rift',
  mbgame_kart: 'KartRider Rush+',
  mbgame_live: 'Free Fire',
  mbgame_pubg: 'PUBG Mobile',
  mbgame_speed: 'Speed Drifters',
  mbgame_cn_pubg: 'Peacekeeper Elite',
  mbgame_tomorrow: 'LifeAfter',
  mbgame_knives_out: 'Knives Out',
  mbgame_close_eye: 'The Game of Killing',
  mbgame_five: 'Identity V',
  mbgame_auto_chess: 'Auto Chess Mobile',
  mbgame_royale: 'Clash Royale',
  mbgame_bnb: 'BnB M',
  mbgame_super_star: 'Super Star mahjong',
  mbgame_dunk: 'Slam Dunk',
  mbgame_glory: 'Arena of Valor',
  mbgame_sky: 'Sky: Children of the Light',
  mbgame_impact: 'Genshin Impact',
  mbgame_ro: 'Ragnarok Online Next Generation',
  mbgame_tom: 'Tom and Jerry: Chase',
  mbgame_duty: 'Call of Duty Mobile',
  mbgame_palyer: 'Play Together',
  pcgame_lol: 'League of Legends',
  pcgame_battle: 'Valorant',
  pcgame_apex: 'APEX',
  pcgame_naraka: 'Naraka：Bladepoint',
  pcgame_tft: 'TFT：Teamfight Tactics',
  pcgame_pubg: 'PUBG',
  pcgame_among: 'Among Us',
  pcgame_pubg_lite: 'PUBG Lite',
  pcgame_duty: 'Call of Duty',
  pcgame_dota2: 'DOTA 2',
  pcgame_csgo: 'CSGO',
  pcgame_division2: "Tom Clancy's The Division 2",
  pcgame_six_siege: "Tom Clancy's Rainbow Six Siege",
  pcgame_fortite: 'Fortnite',
  pcgame_overwatch: 'Overwatch',
  pcgame_flat: 'Human: Fall Flat',
  pcgame_world: 'Minecraft',
  pcgaame_monster_world: 'Monster Hunter: World',
  pcgame_bnb: 'BnB Crazy Arcade',
  pcgame_ring: 'Ring of Elysium',
  pcgame_dead: 'Dead by Daylight',
  pcgame_exile: 'Path of Exile',
  pcgame_war: 'World of Warcraft',
  pcgame_maplestory: 'Maple Story',
  pcgame_rust: 'Rust',
  pcgame_monopoli: 'Monopoli',
  pcgame_overcooked: 'Overcooked',
  pcgame_hearthstone: 'Hearthstone',
  pcgame_gtav: 'GTA V',
  pcgame_warframe: 'Warframe',
  pcgame_knockout: 'Fall Guys: Ultimate Knockout',
  pcgame_super_animal: 'Super Animal Royale',
  pcgame_hunter_rise: 'Monster Hunter Rise',
  pcgame_double: 'It Takes Two',
  pcgame_diablo4: 'Diablo IV',
  pcgame_animal_crossing: 'Animal Crossing: New Horizons',
  gamevoice_lover: 'Pacar Virtual',
  gamevoice_good: 'Suara Indah',
  gamevoice_no_sleep: 'Teman Insomnia',
  gamevoice_alarm: 'Alarm Kecil',
  gamevoice_film_online: 'Film Online',
  gamevoice_ask: 'Konseling Emosional',
  status: 'Status',
  status_newest: 'Terbaru',
  status_recommend: 'Rekomendasi',
  status_track: 'Ikuti',
  status_just: 'Baru dirilis',
  status_comment: 'Segera Tinggalkan Pesan, Bergabung dalam Diskusi!',
  status_like: 'Suka',
  status_push_new: 'Status Rilis',
  status_push: 'Rilis',
  status_share: 'Bagikan suasana hatimu hari ini',
  status_input: 'Klik untuk masukkan topik (maks 10)',
  status_link: 'Klik untuk mengatur skill terkali',
  quickorder: 'Janjian Kilat',
  quickorder_progress: 'Orderan sedang berlangsung',
  quickorder_find: 'Sedang mencari teman',
  quickorder_report: 'Pengaduan',
  quickorder_grab_time: 'Hitung mundur',
  quickorder_complete: 'Orderan Selesai',
  quickorder_record: 'Hanya simpan 10 pesanan terakhir',
  quickorder_want: 'Ingin mencari teman bermain seperti apa?',
  quickorder_remark: 'Catatan: "Suara yang bagus", dll.',
  myorder: 'Saya Ingin Memesan',
  myorder_want: 'Ingin mencari teman bermain seperti apa?',
  myorder_lol: 'League of Legends, Semua Mode dan Level',
  myorder_sex: 'Semua Jemis Kelamin',
  myorder_price: 'Semua Harga',
  myorder_count: 'Jumlah (per game)',
  order_complete: 'Konfirmasi Pesanan',
  order_billing_mode: 'Mode Tagihan',
  order_billing_mode_choose: 'Pilih Mode Tagihan',
  order_normal_mode: 'Mode Standar',
  order_by_count: 'Jumlah Pembelian',
  order_discount: 'Kupon',
  order_none: 'Tidak ada',
  order_fist_discount: 'Diskon Awal',
  order_sum: 'Total',
  order_total_pay: 'Total Pembayaran',
  confirm_order_placement: 'Konfirmasi Pesanan',
  message: 'Pesan',
  message_line: 'Hubungkan ke Line, pesan tidak akan terlewat',
  message_system: 'Notifikasi',
  message_house_keeper: 'Asisten Member',
  message_limit_activity: 'Batas Waktu Event',
  message_guard: 'Pelindung Sistem',
  message_none: 'Belum Ada Pesan',
  chat_share: 'Bagikan',
  chat_block: 'Blokir',
  chat_report: 'Lapor',
  chat_cancel: 'Batal',
  chat_hi: 'Halo, Apa Kabar?',
  chat_hope: 'Ada Waktu Sekarang? (Berharap~)',
  chat_ok: 'Oke, Oke!',
  chat_play: 'Main satu ronde?',
  chat_next: 'Lain kali janjian, bisa kan?',
  chat_some: 'Ayo mulai mengobrol~',
  chat_send: 'Kirim',
  report: 'Pengaduan',
  report_reason: 'Pilih alasan pengaduan',
  report_harassment: 'Mengirim informasi palsu dan mengganggu pengguna',
  report_fake: 'Profil pribadi palsu',
  report_violation: 'Menggunakan metode ilegal saat order atau terima orderan',
  report_no_order: 'Teman bermain tidak terima orderan',
  report_private_order: 'Lapor orderan pribadi (Jika benar ada hadiah)',
  report_other: 'Pelanggaran lainnya',
  report_picture: 'Silakan unggah bukti foto',
  report_5_pic: 'Wajib diisi, unggah hingga 5 materi terkait yang jelas',
  report_push: 'Kirim',
  profile: 'Saya',
  profile_nicee: 'Koin',
  profile_diamond: 'Ahli Berlian',
  film: 'sesi',
  profile_candy: 'Permen',
  profile_discount: 'Kupon',
  profile_history: 'Lihat Riwayat Pesanan',
  profile_orders: 'Orderan saya',
  profile_gifts: 'Hadiah saya',
  profile_see: 'Riwayat Lihat',
  profile_fllow: 'Favorit Saya',
  profile_dressup: 'Tampilan',
  profile_invite: 'Undangan',
  profile_customer: 'Layanan Pelanggan',
  profile_setting: 'Pengaturan',
  profile_player: 'Saya (Panel Pendamping)',
  profile_income: 'Pendapatan',
  profile_exchange: 'Tukar/Hadiahkan',
  profile_skills: 'Skill',
  profile_feed: 'Status',
  profile_client: 'Pelanggan',
  profile_visit: 'Pengunjung',
  profile_self_promotion: 'Promosi Diri',
  profile_fans: 'Penggemar Saya',
  profile_total_rating: 'Nilai',
  profile_voice_room: 'Ruangan Suara Saya',
  material: 'Informasi',
  material_edit: 'Edit',
  material_photo: 'Album',
  material_more_photo:
    'Kamu bisa upload 9 gambar agar dapat lebih mengenal kamu',
  material_lan_desc: 'Tambah bahasa pengantar',
  material_self_dec: 'Tambah perkenalan diri',
  material_sex: 'Jenis Kelamin',
  material_birthday: 'Tanggal Lahir',
  material_address: 'Tempat Tinggal',
  material_mars: 'Mars',
  material_guard: 'Pelindung',
  material_null: 'Kursi kosong',
  material_guard_amount: 'Saat ini amount awal pelindung 750',
  material_fisrt_guard: 'Posisi pelindung di layar awal',
  material_special: 'Bingkai Avatar Eksklusif',
  material_comment: 'Nama panggilan di kolom komentar',
  material_self_desc: 'Deskripsi',
  material_guard_amount_set: 'Atur Jumlah Awal Pelindung',
  material_cancel: 'Batalkan',
  material_save: 'Simpan',
  material_content_null: 'Wah, kosong sekali disini~',
  material_self_profile: 'Informasi Pribadi',
  material_feed: 'Status',
  maerial_feed_push: 'Kirim Status',
  material_no_feed: 'Belum ada status lho~',
  level_desc: 'Detail Level',
  level_now: 'Level saat ini',
  level_normal: 'Umum',
  level_month: 'Bulan ini harus belanja 1 kali lagi agar bisa naik ke VIP 1',
  level_benefits: 'Benefit',
  member_exclusive_skin: 'Tampilan untuk Anggota Ekslusif',
  unlock_with_1688_spending: 'Dapat dibuka dengan belanja bulanan 1688',
  exclusive_avatar_frame:
    'Termasuk Bingkai Avatar Eksklusif, Balon Chat, dan Banner Masuk',
  monthly_10_coin_voucher: 'Kupon 10 koin untuk setiap bulan',
  no_minimum_spending_requirement:
    'Tanpa batas pembelanjaan, dikirim setiap bulan tanggal 1',
  upgrade_pending: 'Menunggu upgrade',
  diamond_member: 'Diamond',
  sparkling_fireworks_avatar_frame: 'Bingkai Avatar "Kembang Api"',
  sparkling_stars_avatar_frame: 'Bingkai Avatar "Bintang Terang"',
  dream_car_mount: 'Kendaraan "Mobil Balap Impian"',
  white_tiger_avatar_frame: 'Bingkai Avatar "Harimau Putih"',
  extreme_car_mount: 'Kendaraan "Mobil Balap Ekstrem"',
  black_gold_member: 'Black Gold',
  qilin_avatar_frame: 'Bingkai Avatar "Qilin"',
  white_tiger_mount: 'Kendaraan "Harimau Putih"',
  crystal_shine_avatar_frame: 'Bingkai Avatar "Kilauan Kristal"',
  qilin_mount: 'Kendaraan "Qilin"',
  exclusive_gift_pyramid: 'Hadiah Eksklusif "Piramida"',
  legendary_member: 'Legend',
  diamond_chest_available_this_month:
    'Bulan ini bisa dapat harta karun diamond',
  member_benefits_description4:
    '4. Nomor cantik, gelar kustom, pendant kustom, dan bingkai avatar kustom perlu menghubungi admin Nicee setelah mencapai level yang sesuai.',
  member_benefits_description5:
    '5. Nomor cantik 6 digit maksimal dapat memilih 5 angka berurutan, 5 digit maksimal 4 angka berurutan, dan 4 digit maksimal 3 angka berurutan. Contoh: 688888, 68888, 6888',
  member_benefits_description6:
    '5. Benefit member akan diperbarui dari waktu ke waktu dan akan diumumkan di "Aturan Level" 15 hari sebelum setiap pembaruan. Platform berhak atas interpretasi akhir.',
  current_defense_attempts: 'Jumlah pengamanan level saat Ini',
  not_met_requirements: 'Belum capai standar',
  cancel_10_quick_dates_per_month:
    'Setiap bulan dapat batalkan 10 pesanan janjian kilat',
  free_defense_privilege: 'Hak untuk Menjaga Tingkat Secara Gratis',
  specify_5_recommended_privileges:
    'Hak untuk rekomendasikan teman main sebanyak 5 Kali',
  legend_avatar_frame: 'Bingkai Avatar "Legendaris"',
  phoenix_mount: 'Kendaraan "Phoenix"',
  exclusive_gift_sky_city: 'Hadiah Eksklusif "Kota di Langit"',
  specify_1_app_cover_privilege:
    'Hak untuk atur tampilan APP teman bermain 1 kali',
  king_legend_avatar_frame: 'Bingkai Avatar "Raja Legend"',
  dragon: 'Kendaraan "Dewa Naga"',
  exclusive_gift_legend_throne: 'Hadiah Eksklusif "Tahta Legenda"',
  levelrule: 'Aturan Level',
  levelrule_1:
    'Perhitungan masa berlaku: dimulai dari sejak mendapatkan level ini dan berlangsung hingga akhir bulan berikutnya.',
  levelrule_2:
    'Contoh: User mendapatkan VIP 5 tanggal 5 Feb, VIP 5 akan expired pada tanggal 31 Maret, maka tanggal 1 April akan mulai perhitungan baru',
  levelrule_3:
    'Upgrade Level: dengan berbelanja (order, hadiah) user dapat upgrade level. Dengan berbelanja dan memenuhi syarat kenaikan level, maka level baru didapat pada hari yang sama dan berakhir pada akhir bulan berikutnya',
  levelrule_4:
    'Contoh: Pada tanggal 5 Feb user pada level VIP 5, tanggal 6 Feb user belanja dan naik menjadi level VIP 6, maka VIP 6 akan expired pada tanggal 31 Maret',
  levelrule_5:
    'Jaga Level: jika user sudah berada di level tertentu, pada saat bulan expired itu melakukan pembelian mencapai 70% dari level tersebut, maka bisa langsung mempertahankan level tersebut',
  levelrule_6:
    'Contoh: User pada tanggal 5 Feb berada di VIP11. Misal untuk mencapai level VIP 11 ini harus melakukan pembelian 100.000 yang berlaku hingga 31 Maret, maka sebelum 1 April pembelian harus mencapai 70.000 agar bulan depan dapat melakukan jaga level',
  levelrule_7:
    'Turun level: saat level user expired di bulan itu tapi pembelian belum mencapai syarat jaga level, maka perhitungan di bulan berikutnya level akan turun, jika di bulan berikutnya belum juga memenuhi syarat jaga level maka akan turun lagi,dan seterusnya.',
  levelrule_8:
    'Contoh: Pada tanggal 5 Februari user berada di VIP5, tetapi pada perhitungan akhir (bulan Maret) pembelian belum mencapai syarat VIP5 ataupun 70% dari VIP4 dan hanya mencapai syarat pembelian 70% dari VIP3, maka pada tanggal 1 April level akan turun sampai VIP3',
  retention_privilege: 'Privilege Jaga Level',
  retention_privilege_1:
    'Jika dalam periode ini pembelian belum cukup untuk menjaga level, maka bisa menggunakan 1 kali 【Privilege Jaga Level】untuk tetap mempertahankan level member sampai akhir bulan berikutnya. Selanjutnya level member apakah tetap dapat dipertahankan ditentukan berdasarkan perhitungan akhir bulan dan pembelian user. 【Privilege Jaga Level】:Setiap mempertahankan level selama 3 bulan berturut akan mendapatkan 1 kali kesempatan 【Privilege Jaga Level】',
  retention_privilege_2: 'Maksimal memiliki 2 kesempatan',
  retention_privilege_3: 'Tidak dapat digunakan selama 2 bulan berturut-turut',
  retention_privilege_4:
    'Jika turun level dan kembali ke SVIP1,SVIP2 atau bulan lalu anda telah menggunakan【Privilege Jaga Level】, maka jumlah mempertahankan level bulanan akan dihitung ulang',
  retention_privilege_5:
    'Jika user naik ke level lebih tinggi tetapi memiliki privilege jaga level yang belum digunakan, maka jumlah privilege jaga level akan berkurang satu',
  retention_privilege_6: 'Rekomendasi privillege untuk teman bermain',
  retention_privilege_7:
    'Setiap bulan anda dapat merekomendasikan teman bermain di waktu tertentu dan dapat mengatur logo khusus untuk teman bermain (durasi 6 jam)',
  retention_privilege_8: 'Privilege Sampul APP untuk teman bermain',
  retention_privilege_9:
    'Setiap bulan anda dapat merekomendasikan sampul di APP teman bermain satu kali, setelah itu semua user dapat melihat semua sampul yang anda rekomendasikan ke teman bermain',
  recharge: 'Top Up',
  recharge_1: 'Promosi terbatas: Pesta Summer',
  recharge_2: 'Top Up ID',
  recharge_3: 'Nama',
  recharge_4: 'Pilih jumlah',
  recharge_5: 'Pilih Metode Pembayaran',
  id_recharge_card_description: 'Visa · Mastercard',
  id_recharge_confirm_title: 'Konfirmasi Top Up',
  id_recharge_confirm_account: 'UUID: {uuid}\nNama: {nickname}',
  id_recharge_paypal_description: 'Bayar dengan akun PayPal',
  id_recharge_paypal_currency_missing:
    'Mata uang PayPal belum dikonfigurasi untuk nominal ini',
  id_recharge_paypal_currency_unsupported:
    'PayPal tidak mendukung pembayaran langsung dalam IDR',
  id_recharge_paypal_load_failed: 'Gagal memuat PayPal. Silakan coba lagi',
  id_recharge_payment_cancelled: 'Pembayaran dibatalkan',
  id_recharge_payment_failed: 'Pembayaran gagal',
  recharge_6:
    'Kartu Kredit (1:1Gratis terbatas)(Visa/MasterCard/UnionPay/AmEx)',
  recharge_7: 'Kartu Kredit (Visa/MasterCard/JCB)',
  recharge_8: 'Transfer ATM',
  recharge_9: 'Barcode',
  recharge_10: 'PayPal',
  recharge_11: 'Konfirmasi Top Up',
  discount: 'Kupon',
  discount_1: 'Tukar Kupon',
  discount_2: 'Tidak ada kupon',
  discount_3: 'Kupon Tidak Valid',
  discount_4: 'Konfirmasi Penukaran',
  discount_5: 'Masukkan kode penukaran',
  discount_6: 'Klik untuk memasukkan kode penukaran',
  discount_7: 'Tukar sekarang',
  myorder_1: 'Panduan orderan',
  myorder_2: 'Semua orderan',
  myorder_3: 'Orderan dalam proses',
  myorder_4: 'Riwayat orderan',
  myorder_5: 'Tidak ada orderan',
  orderdetail: 'Detail orderan',
  orderdetail_1: 'Nomor orderan',
  orderdetail_2: 'Dibatalkan',
  orderdetail_3: 'Total hadiah',
  orderdetail_4: 'Jumlah',
  orderdetail_5: 'Order',
  orderdetail_6: 'Batalkan orderan',
  gifts: 'Hadiah',
  gifts_1: 'Hadiah yang diterima',
  gifts_2: 'Anda belum menerima hadiah, teruslah berusaha~',
  gifts_3: 'Hadiah yang dikirim',
  gifts_4: 'Anda belum mengirim hadiah ya~',
  dressup_center: 'Bingkai avatar',
  dressup_center_1: 'Balon chat',
  dressup_center_2: 'Banner masuk',
  dressup_center_3: 'Kendaraan',
  dressup_center_4: 'Bunga penuh cinta',
  dressup_center_5: 'Bunga bermekaran',
  dressup_center_6: 'Diperoleh saat event Greenday',
  dressup_center_7: 'Champion',
  dressup_center_8: 'Runner Up',
  dressup_center_9: '3rd Runner Up',
  dressup_center_10: 'Delapan Besar',
  dressup_center_11: 'Bos',
  dressup_center_12: 'Diperoleh saat event tahunan',
  dressup_center_13: 'Bola Lingkar Merah',
  dressup_center_14: 'Bola Lingkar Biru',
  dressup_center_15: 'Diperoleh saat event piala dunia',
  dressup_center_16: 'Order Mingguan',
  dressup_center_17: 'Diperoleh juara order mingguan',
  dressup_center_18: 'Ayah',
  dressup_center_19: 'Bayi',
  dressup_center_20: 'Diperoleh saat event hari ayah',
  dressup_center_21: 'Boat Naga',
  dressup_center_22: 'Bakcang',
  dressup_center_23: 'Diperoleh saat event Mid Autumn',
  dressup_center_24: 'Gelombang suara',
  dressup_center_25: 'Menunggumu',
  dressup_center_26: 'Diperoleh saat event nyayian sampai ke hati',
  dressup_center_27: 'Malaikat Kesayangan',
  dressup_center_28: 'Kristal Kesayangan',
  dressup_center_29: 'Diperoleh saat event lomba poin sayang',
  apply_for_settlement: 'Pengajuan bergabung',
  apply_for_settlement_1: 'Nicee mengundang Anda untuk menjadi mitra kami',
  apply_for_settlement_2: 'Kami menunggu seseorang sepertimu',
  apply_for_settlement_3:
    'Berpikir cepat, senang ngobrol; senang bermain game dan juga senang berteman.',
  apply_for_settlement_4:
    'Baik karena rasa ingin tahu atau pekerjaan, Anda ingin menjadi mitra yang baik.',
  apply_for_settlement_5:
    'Jika Anda adalah orang seperti itu, segera klik dan ajukan untuk bergabung, dan mulailah perjalanan Anda sebagai mitra kami!',
  apply_for_settlement_6:
    'Saya telah membaca dan setuju dengan "Pedoman perilaku mitra nicee" dan "Ketentuan Layanan dan Kebijakan Privasi".',
  apply_for_settlement_7: 'Ajukan sekarang',
  invite: 'Undagan',
  invite_1: 'Reward komisi hingga 66 hari',
  invite_2: 'Undang teman dan dapatkan uang tunai',
  invite_3: 'Bagikan',
  invite_4: 'Putar 1 kali, Sisa kesempatan 0 kali',
  invite_5: 'Putar 10 kali, Sisa kesempatan 0 kali',
  invite_6: 'Terima kasih atas kunjungan',
  invite_7: 'Kode undangan saya',
  invite_8: 'Klik untuk salin',
  invite_9:
    'Setiap kali anda mengundang satu orang teman menggunakan kode undangan,maka anda akan mendapatkan 1 kali kesempatan undian',
  invite_10:
    'Setiap teman yang kamu udang isi saldo 1000 koin nicee, kamu berhak mendapatkan 1 kali kesempatan undian',
  invite_11: 'Total pendapatan',
  invite_12:
    'Koin nicee telah otomatis masuk ke dompet anda (dapat di tarik saat menarik pendapatan)',
  invite_13: 'Riwayat aktivitas saya',
  invite_14:
    'Tidak ada riwayat, ayo cepat ajak teman kamu untuk daftar sekarang',
  invite_15: 'Sambungkan kode undangan teman',
  invite_16:
    'Saya daftar dengan kode undangan, sambungkan kode undangan agar teman mendapatkan kesempatan undian',
  niceebot: 'Robot pintar nicee',
  niceebot_1:
    'Saya adalah robot pintar nicee, apakah ada yang bisa saya bantu? Mohon deskripsikan permasalahan anda~',
  niceebot_2: 'Apakah Anda mengalami masalah berikut:',
  niceebot_3: 'Apa ID nicee saya?',
  niceebot_4: 'Bagaimana cara mendaftar sebagai mitra?',
  niceebot_5:
    'Bagaimana cara mendaftar keahlian? Materi apa saja yang perlu dipersiapkan?',
  niceebot_6: 'Bagaimana cara membuat kartu suara?',
  niceebot_7: 'Bagaimana pertihungan pesanan dianggap selesai?',
  niceebot_8: 'Apa yang harus dilakukan jika pesanan terjadi masalah?',
  niceebot_9: 'Dimana saya bisa rebut pesanan?',
  niceebot_10: 'Bagaimana cara menyimpan nilai?',
  niceebot_11:
    'Setelah pembayaran berhasil 30 menit isi saldo belum berubah, apa yang harus saya lakukan?',
  niceebot_12: 'Bagaimana penghasilan mitra bermain dijadikan uang tunai?',
  niceebot_13: 'Mengapa foto profil saya tidak lulus tinjauan?',
  niceebot_14:
    'Saya tidak melihat tombol asisten pelanggan atau fitur baru yang diterbitkan pihak resmi, apakah sistem bermasalah?',
  niceebot_15: 'Dimana saya bisa mengajukan verifikasi foto?',
  niceebot_16:
    'Silakan beri deskripsi tentang masalah anda, sebisa mungkin yang singkat ya^^',
  niceebot_17: 'Kirim',
  niceebot_18: 'Tips',
  niceebot_19: 'Anda yakin ingin mengakhiri percakapan ini?',
  niceebot_20: 'Ya',
  niceebot_21: 'Batal',
  official_customer_app_open_failed:
    'Apakah aplikasi Nicee sudah terpasang? Jika belum, Anda dapat mengunduhnya dari toko aplikasi.',
  official_customer_go_to_store: 'Buka toko aplikasi',
  leaderboard: 'Rangking',
  leaderboard_1: 'Selebriti',
  leaderboard_2: 'Newbie',
  leaderboard_3: 'Favorit',
  leaderboard_4: 'Order',
  leaderboard_5: 'Hadiah',
  leaderboard_6: 'Harian',
  leaderboard_7: 'Mingguan',
  leaderboard_8: 'Reward dan peraturan',
  leaderboard_9: 'Pesona',
  luck_party: 'Pesta Permen Keberuntungan',
  luck_party_1: 'Undian berhadiah koin dan diamond untuk member',
  luck_party_2:
    'Pesta permen keberuntungan khusus member, dapatkan koin dan diamond makin banyak reward, ditunggu kedatangan anda!',
  luck_party_3: 'Waktu event',
  luck_party_4: 'Permen saya',
  luck_party_5: 'Semoga beruntung',
  luck_party_6: 'Mulai undian',
  luck_party_7: 'Setiap kali anda menghabiskan 200 permen atau 500 diamond',
  luck_party_8: '10 besar privilege member, tunggu anda ambil',
  luck_party_9: 'VIP1 atau lebih bisa mendapat tampilan khusus member',
  luck_party_10: 'VIP8 atau lebih bisa mendapat bingkai avatar baru',
  luck_party_11: 'VIP5 atau lebih bisa mendapatkan kupon gratis',
  luck_party_12: 'VIP10 atau lebih bisa mendapatkan diamond gratis',
  luck_party_13: 'VIP9 atau lebih bisa mendapatkan kendaraan khusus',
  luck_party_14:
    'Mulai pengalaman anda dengan kendaraan khusus (mobil balap impian, mobil balap ekstrim,dewa naga) agar terlihat terhormat',
  luck_party_15: 'VIP12 atau lebih bisa menikmati hadiah eksklusif',
  luck_party_16:
    'Nikmati pengalaman anda dengan hadiah khusus(Negeri di awan,Tahta Raja), agar terus memicu antusias lainnya',
  luck_party_17: 'Lihat 10 besar privilege member',
  palyer_panel_1: 'Penghasilan',
  palyer_panel_2: 'Tukar/Hadiah',
  palyer_panel_3: 'Hadiah 1000 Diamond',
  palyer_panel_4: 'Skill',
  palyer_panel_5: 'Status',
  palyer_panel_6: 'Pelanggan',
  palyer_panel_7: 'Kunjungan Terbaru',
  palyer_panel_8: 'Promosi Diri Sendiri',
  palyer_panel_10: 'Orderan Saya',
  palyer_panel_11: 'Hadiah Saya Menerima',
  palyer_panel_12: 'Penggemar Saya',
  palyer_panel_13: 'Nilai',
  palyer_panel_14: '{msg} skor,lebih tinggi dari{msg2} %',
  palyer_panel_15: 'Ruangan Suara Saya',
  palyer_panel_16: 'Undangan',
  palyer_panel_17: 'Layanan Pelanggan',
  palyer_panel_18: 'Pengaturan',
  palyer_panel_19: 'Rincian Penghasilan',
  palyer_panel_20: 'Jumlah penarikan',
  palyer_panel_21: 'Memproses jumlah',
  palyer_panel_22: 'Total Penghasilan',
  palyer_panel_23: 'Rincian Memproses jumlah',
  palyer_panel_24: 'Rincian penghasilan/ pengeluaran',
  palyer_panel_25: 'Belum ada riwayat',
  line_1: 'Pengaturan Notifikasi LINE',
  line_2:
    'Saat seseorang ada meninggalkan pesan atau ada pesanan baru akan masuk di LINE sebagai notifikasi',
  line_3: 'Silakan baca langkah-langkah dibawah ini, lalu klik tombol aktif',
  line_4: 'Klik tombol buka tutup di sisi kanan bawah',
  line_5:
    'Masuk LINE di halaman web baru, jika anda telah install LINEapp, tarik kebawah akan keluar "Buka di LINE", klik itu dan anda bisa langsung masuk',
  line_6:
    'Setelah berhasil Login, klik pilihan pertama"Terima notifikasi LINE lewat private chat"',
  line_7: 'Klik tombol "Setuju dan hubungkan" di sisi paling bawah halaman',
  line_8: 'Aktifkan notifikasi LINE',
  skill_manage_1: 'Saat ini dapat menerima orderan',
  skill_manage_2: 'Tambahkan keahlian baru',
  skill_manage_3: 'Verifikasi berhasil, Silahkan lengkapi informasi keahlian',
  skill_cancelled_not_applied: 'Belum mengajukan sertifikasi, ubah',
  myclient_1: 'Pelanggan saya',
  myclient_2:
    'Untuk membantu Anda mengelola pelanggan dengan baik, kami telah menyiapkan bantuan ,ayo lihat sekarang!',
  myclient_3: 'Lama tidak bertemu',
  myclient_4:
    'Menampilkan pesanan pelangan 7-30 hari, jika teman lama Anda muncul jangan lupa disapa ya~',
  myclient_5: 'Pendatang baru di platform',
  myclient_6: 'Sementara tidak ada user baru, tetap jagalah teman lama Anda',
  recent_visitor_1: 'Kunjungan terbaru',
  recent_visitor_2: 'Kunjungan 30 hari terakhir',
  recent_visitor_3: 'Bagaimana mendapatkan lebih banyak popularitas',
  recent_visitor_4: 'Kunjungan pertama',
  mypic_1: 'Foto terverifikasi',
  mypic_2: 'Sangat Terpukau',
  mypic_3:
    'Selesaikan verifikasi identitasmu dan nikmati privilege besar selama 3 hari',
  mypic_4: 'Foto Lencana',
  mypic_5: 'Mendapatkan logo resmi',
  mypic_6: 'Rekomendasi resmi',
  mypic_7: 'Meningkatkan popularitas',
  mypic_8: 'Pesanan meningkat',
  mypic_9: 'Menarik lebih banyak user',
  service_1: 'Status Layanan',
  service_2: 'Penilaian',
  service_3: 'Data 60 hari terakhir',
  service_4: 'Semua keahlian',
  service_5: 'Persentase respon',
  service_6: 'Di bawah standar',
  service_7:
    'Persentase respon anda di bawah rata-rata, perlu kerja keras lagi~',
  service_8: 'Jumlah user baru yang pesan',
  service_9: 'Jumlah user yang pesan kedua kali nya',
  service_10: 'Nominal rata-rata pesanan kembali',
  service_11: 'Nominal pesanan kembali',
  service_12: 'Persentase balasan dalam 1 menit',
  service_13:
    'Dalam status dapat menerima pesanan, data dalam 1 menit membalas rendah, ini dapat mempengaruh popularitas dan pesanan anda',
  service_14: 'Persentase ulasan positif',
  service_15:
    'Data ulasan bintang 5 dengan kalimat diatas 5 kata rendah, ingat untuk meminta user memberikan ulasan ya!',
  service_16: 'Jumlah ulasan positif',
  service_17: 'Total ulasan positif',
  myroom: 'Ruangan saya',
  who_1: 'Lihat saya',
  who_2: 'Kunjungan 30 hari terakhir',
  who_3: 'Ayo ngobrol',
  legal_rules_title: 'Pedoman Perilaku Mitra nicee',
  legal_privacy_title: 'Ketentuan Layanan dan Kebijakan Privasi',
  who_4:
    'Mitra yang bergabung dengan nicee wajib berusia minimal 18 tahun dan memiliki perilaku baik , setelah dibaca dimengerti dan menyetujui semua isi layanan dan update selanjutnya, mempermudah dalam pemakaian layanan platform\n\nDemi menciptakan lingkup platform yang sehat, melindungi hak privacy user, maka mitra diwajibkan mengikuti kode etik sebagai berikut:\n\n1. Dilarang memposting informasi yang melanggar peraturan termasuk terorisme, pornografi, kekerasan, perjudian dan membahayakan anak dibawah umur pada informasi pribadi, ulasan, deskripsi skill, ataupun pesan pribadi\n\n2. Dilarang memposting informasi spam seperti promosi, penjualan, ataupun keuntungan pada infromasi pribadi, ulasan, deskripsi skill, ataupun pesan pribadi, akan mengganggu pengalaman user\n\n3. Dilarang memposting informasi yang melanggar hak cipta termasuk informasi tanpa izin pengguna seperti foto,nama ataupun karya pribadi pada informasi pribadi, ulasan, deskripsi skill, dan pesan pribadi\n\n4. Dilarang memposting informasi palsu seperti penipuan atau hoax pada informasi pribadi, ulasan, deskripsi skill, dan pesan pribadi\n\n5. Dilarang memposting iklan dalam informasi pribadi, ulasan, deskripsi skill, dan pesan pribadi\n\nMempromosikan platform lain tanpa izin otoritas pihak ketiga/platform/sarana dalam bentuk avatar, gambar, nama, judul,deskripsi, ulasan atau lainnya\n\n6. Dilarang melakukan transaksi di luar platform dengan metode apa pun.\n\n7. Dilarang melecehkan orang lain, termasuk mencaci maki, ejekan, serangan pribadi\n\n8.Dilarang memalsukan data, termasuk melakukan kecurangan manual atau mesin, sengaja mendaftarkan banyak akun dan kecurangan lainnya\n\n9. Dilarang merusak kepentingan platform atau mengganggu ketertiban platform.\nMengganggu manajemen platform dalam bentuk apa pun, mengacaukan ketertiban platform, atau merugikan hak-hak pengguna dan platform.\n\nPetunjuk Verifikasi dan Penalti:\n1.Platform akan mengonfirmasi pelanggaran berdasarkan feedbcak user, pemantauan platform ataupun metode lainnya\n\n2.Untuk menjaga privasi user, mohon para mitra tetap menyimpan riwayat main bersama sebagai verifikasi\n\n3.Jika user tidak menaati peraturan berikut dan ditemukan melakukan pelanggaran, maka platform akan mengambil tindakan hukuman sesuai tingkat keparahan berupa peringatan, pembatasan beberapa fitur, pemblokiran akun bahkan pembekuan akun dalam waktu yang cukup panjang\n\nPerusahaan berhak sewaktu-waktu mengganti atau mengubah peraturan mitra, dan akan diberitahukan pada web platform (https://nicee.tw), Anda diharapkan memperhatikan perubahan atau update ini, karna tidak akan ada pemberitahuan secara pribadi. Jika ada perubahan atau update dan anda tetap menggunakan platform ini , berarti anda telah membaca, memahami dan menyetujui perubahan atau update, dan juga menyetujui menaati semua peraturan mitra.\n\nKami berkomitmen untuk menciptakan lingkungan pelayanan yang aman dan sehat bagi para pengguna, perkembangan platform membutuhkan dukungan dan kerjasama Anda. Jika dalam penggunaan ada saran dan kritik, silakan hubungi customer service kami, semoga anda senang bermain di nicee',
  who_5:
    'Ketentuan layanan dan kebijakan privasi ini (disebut sebagai "perjanjian") menentukan hak dan kewajiban antara Anda dan "nicee". Untuk melindungi hak Anda (selanjutnya disebut sebagai "pengguna"), silakan membaca ketentuan ini dengan cermat sebelum mendaftar " Nicee" (disebut sebagai "platform").\n1. Definisi Istilah\n(1) "Pengguna": Merujuk pada individu yang mendaftar, masuk, dan menggunakan layanan platform ini.\n(2) "Layanan": Merupakan layanan yang disediakan oleh perusahaan di platform ini bagi pengguna untuk berbagi, berkomunikasi, dan mendapatkan informasi terkait permainan online, dengan tujuan mencocokkan pengguna platform untuk interaksi real-time terkait "panduan bermain".\n2. Pengenalan dan Penerimaan Syarat\n(1) Saat Anda menyelesaikan pendaftaran atau mulai menggunakan layanan ini, berarti Anda telah membaca, memahami, dan setuju untuk menerima seluruh isi dari Perjanjian Layanan ini. Jika Anda tidak setuju dengan isi Perjanjian Layanan ini atau negara atau wilayah Anda mengeluarkan seluruh atau sebagian isi dari Perjanjian Layanan ini, Anda seharusnya tidak mendaftar atau masuk ke situs web platform ini dan segera berhenti menggunakan layanan terkait platform ini.\n(2) Perusahaan berhak memodifikasi atau mengubah isi Perjanjian Layanan ini kapan saja dan mengumumkannya di situs web platform ini (https://www.nicee.tw/). Harap perhatikan perubahan atau modifikasi tersebut, tanpa pemberitahuan lebih lanjut. Jika Anda terus menggunakan layanan platform ini setelah modifikasi atau perubahan, berarti Anda telah membaca, memahami, dan setuju untuk menerima perubahan atau modifikasi tersebut dan sepenuhnya mematuhi perjanjian ini dan peraturan lainnya.\n(3) Jika Anda bukan orang dengan kemampuan bertindak penuh berusia minimal delapan belas tahun, Anda harus meminta orang tua atau wali Anda untuk membaca, memahami, dan menyetujui seluruh isi Perjanjian Layanan ini dan perubahan berikutnya sebelum menggunakan layanan platform ini. Saat Anda menggunakan layanan ini, diasumsikan bahwa orang tua atau wali Anda telah membaca, memahami, dan menyetujui seluruh isi Perjanjian Layanan ini dan perubahannya.\n(4) Untuk mempromosikan perkembangan fisik dan mental anak dan remaja dan melindungi hak-hak mereka, Anda mengerti bahwa platform ini melibatkan "Metode Manajemen Klasifikasi Perangkat Lunak Game" di bawah standar klasifikasi "Pembimbing 15 Tahun". Sebelum memilih untuk menggunakan layanan yang sesuai, Anda harus terlebih dahulu memahami simbol dan usia yang sesuai untuk setiap permainan yang ditunjukkan di situs web resmi permainan. Saat menggunakan layanan tertentu, diasumsikan bahwa Anda telah memenuhi persyaratan usia untuk bermain game sesuai dengan peraturan yang relevan.\n3. Pendaftaran Pengguna dan Penjagaan Akun\n(1) Anda setuju untuk memberikan data yang benar dan terbaru saat mendaftar sebagai pengguna (lihat Pasal 6 "Kebijakan Privasi") dan hanya dapat mendaftar dan masuk dengan satu akun, tanpa pendaftaran atau masuk berulang. Jika ada perubahan pada data yang Anda masukkan nantinya, Anda harus segera memperbaruinya secara online. Jika informasi pribadi yang Anda berikan tidak benar atau menyesatkan, perusahaan berhak untuk mengakhiri kualifikasi pengguna Anda kapan saja dan menghentikan hak untuk menggunakan semua layanan.\n(2) Anda harus memilih nama pengguna dan kata sandi sendiri untuk membuat akun. Jika nama pengguna Anda diduga melanggar hak, perusahaan dapat memintanya untuk mengubah nama pengguna atau menghapus akun yang melanggar hak.\n(3) Anda setuju bahwa satu akun hanya dapat digunakan oleh satu orang pada saat yang sama dan Anda tidak akan mentransfer, menyewakan, atau meminjamkan akun dan kata sandi Anda kepada orang lain.\n(4) Setelah menyelesaikan pendaftaran, pengguna akan mendapatkan kata sandi dan akun pengguna tertent\nPara pendamping di nicee harus berusia minimal delapan belas tahun dan memiliki kemampuan bertindak sepenuhnya, telah membaca, memahami, dan setuju dengan semua isi perjanjian layanan ini dan perubahan yang mungkin terjadi di masa depan sebelum menggunakan layanan platform ini.\n\nUntuk menciptakan atmosfer platform yang sehat dan melindungi hak-hak pengguna, para pendamping diminta untuk mematuhi pedoman perilaku berikut:\n\n1. Dilarang memposting informasi yang melanggar hukum dalam informasi pribadi, ulasan, deskripsi skill, atau pesan pribadi.\nIni termasuk, tetapi tidak terbatas pada, informasi ilegal seperti merugikan keamanan, konten cabul, kekerasan, perjudian, merugikan anak-anak di bawah umur, dan sebagainya.\n\n2. Dilarang memposting informasi spam dalam informasi pribadi, ulasan, deskripsi kemampuan, atau pesan pribadi.\nIni termasuk, tetapi tidak terbatas pada, promosi, penjualan, atau tujuan menguntungkan yang mengganggu pengalaman pengguna.\n\n3. Dilarang memposting informasi yang melanggar hak cipta dalam informasi pribadi, ulasan, deskripsi kemampuan, atau pesan pribadi.\nIni termasuk, tetapi tidak terbatas pada, penggunaan gambar, nama, atau karya orang lain tanpa izin.\n\n4. Dilarang memposting informasi palsu.\nIni termasuk, tetapi tidak terbatas pada, penipuan, kabar angin, atau informasi tidak benar lainnya.\n\n5. Dilarang memposting informasi promosi.\nPromosi atau mengajak penggunaan platform pesaing dengan cara apapun, termasuk tetapi tidak terbatas pada avatar, gambar, nama panggilan, judul, deskripsi, ulasan, dan sebagainya.\n\n6. Dilarang melakukan transaksi di luar platform.\nMelakukan pemesanan di luar platform melalui metode apa pun.\n\n7. Dilarang mengganggu atau menghina orang lain.\nIni termasuk, tetapi tidak terbatas pada, menghina, mengejek, atau serangan pribadi terhadap pengguna platform.\n\n8. Dilarang memalsukan data interaksi.\nIni termasuk, tetapi tidak terbatas pada, manipulasi data dengan curang, mendaftar banyak akun dengan niat buruk, dan perilaku curang lainnya.\n\n9. Dilarang merusak kepentingan platform atau mengganggu ketertiban platform.\nMengganggu manajemen platform dalam bentuk apa pun, mengacaukan ketertiban platform, atau merugikan hak-hak pengguna dan platform.\n\nPenjelasan verifikasi dan hukuman oleh platform:\n\n1. Platform akan mengonfirmasi pelanggaran melalui umpan balik pengguna, pemantauan platform, dan metode lainnya.\n\n2. Untuk melindungi hak-hak pengguna, para pendamping diminta untuk menyimpan catatan interaksi mereka untuk verifikasi.\n\n3. Jika pengguna tidak mematuhi pedoman perilaku di atas dan ditemukan melakukan pelanggaran, platform akan mengambil tindakan hukuman sesuai dengan tingkat keseriusan, termasuk peringatan, pembatasan sebagian fungsionalitas, pemblokiran akun, atau pembekuan akun untuk waktu yang lama bagi pelanggaran serius.\n\nPerusahaan berhak untuk mengubah atau mengganti pedoman perilaku pendamping ini kapan saja dan akan mengumumkannya di situs web platform (https://nicee.tw). Mohon selalu periksa perubahan atau penggantian tersebut. Jika Anda terus menggunakan layanan platform setelah perubahan atau penggantian, dianggap Anda telah membaca, memahami, dan setuju untuk menerima perubahan atau penggantian tersebut dan sepenuhnya mematuhi pedoman perilaku pendamping ini.\n\nKami berkomitmen untuk menciptakan lingkungan layanan yang aman dan sehat bagi semua pengguna. Pengembangan platform memerlukan dukungan dan kerja sama Anda. Jika Anda memiliki saran atau umpan balik selama penggunaan, silakan hubungi asisten layanan pelanggan kami. Semoga Anda menikmati waktu di nicee.\n（5） Jika Anda menemukan akun Anda digunakan secara ilegal atau ada kerusakan keamanan yang tidak normal, harap segera beritahu perusahaan kami agar penggunaan akun tersebut dapat dihentikan; namun, jika akun dan kata sandi Anda dicuri, digunakan secara tidak semestinya, atau dalam situasi lain yang tidak dapat dipastikan penggunaannya oleh Anda, kerugian yang timbul dari hal tersebut, kecuali dapat dibuktikan karena kesalahan perusahaan kami, perusahaan kami tidak akan bertanggung jawab atas penggunaan akun sebelum kami menerima pemberitahuan Anda.\n\n4、 Metode Pembayaran dan Pembelian Koin "nicee"\n（1） Anda dapat mengisi saldo "nicee" atau membeli layanan lain menggunakan metode pembayaran yang disediakan oleh platform ini, tetapi Anda harus menyediakan peralatan komputer yang diperlukan untuk menjelajahi platform ini, termasuk namun tidak terbatas pada "biaya koneksi internet", "biaya telepon" dan biaya telekomunikasi lainnya.\n（2） Anda secara jelas memahami dan setuju bahwa jika Anda ingin menggunakan fitur tertentu dalam layanan nicee (misalnya mengirim hadiah, memesan pendamping bermain, dll.), Anda harus membeli koin melalui saluran yang disetujui oleh nicee. Jika melanggar ketentuan di atas, perusahaan kami berhak untuk menonaktifkan atau menghapus akun Anda. Anda tidak akan dapat mengakses semua data Anda melalui akun Anda, termasuk koin dan kupon diskon di akun Anda.\n（3） Anda memahami dan setuju bahwa pembelian koin Anda adalah hasil dari pertimbangan yang matang, kecuali diatur lain oleh hukum, nicee tidak memiliki kewajiban untuk mengembalikan uang Anda untuk alasan apa pun. Jika Anda membatalkan pesanan setelah membeli koin melalui toko aplikasi, kami akan mengambil kembali koin yang telah Anda gunakan, serta semua efek yang menyertainya, termasuk namun tidak terbatas pada manfaat, level, poin pengalaman, tampilan acara, peringkat, dll.\n（4） Anda memahami dan setuju bahwa koin yang Anda dapatkan di layanan nicee (seperti acara festival, acara peringkat, hadiah saling memberi) tidak dapat diubah menjadi uang tunai. Semua pengguna tidak boleh melakukan transaksi uang tunai, menjual atau meminjamkan akun secara pribadi. Jika melanggar ketentuan di atas, perusahaan kami memiliki hak untuk menonaktifkan atau menghapus akun Anda. Anda tidak akan dapat menggunakan layanan melalui akun Anda.\n\n5、 Pedoman Pengguna dan Tanggung Jawab Penggunaan Platform\n（1） Pedoman Pengguna: Anda berjanji untuk tidak menggunakan layanan ini untuk tujuan atau cara ilegal, dan berjanji untuk mematuhi undang-undang dan kebiasaan internasional yang relevan dari Republik Cina. Jika Anda adalah pengguna dari luar Republik Cina, Anda setuju untuk mematuhi hukum negara atau wilayah tempat tinggal Anda. Anda setuju dan menjamin tidak akan menggunakan layanan platform ini untuk melanggar hak orang lain atau tindakan ilegal, dan mematuhi pedoman pengguna berikut:\n\n[saya akan membagi poin-poin selanjutnya menjadi beberapa bagian untuk memudahkan pemahaman.]\n\n1. Tidak mempublikasikan atau mengirimkan teks, gambar, atau file apapun yang bersifat fitnah, menghina, mengancam, agresif, tidak senonoh, cabul, tidak benar, melanggar ketertiban umum atau norma kesopanan, atau ilegal; tidak melanggar hak atas nama, hak cipta, hak kekayaan intelektual, rahasia dagang, dan lain-lain.\n2. Tidak mengekspresikan konten terbatas sesuai dengan "Pedoman Klasifikasi Perangkat Lunak Permainan" melalui gambar, teks, video, dan suara kepada orang di bawah 18 tahun.\n3. Tidak mempublikasikan atau mengirimkan informasi yang melanggar hak kekayaan intelektual orang lain.\n4. Tidak menggunakan identitas palsu, penipuan, atau cara lain yang tidak sah untuk melakukan pembayaran atau top-up.\n5. Tidak mentransfer, menyewakan, atau meminjamkan akun Anda kepada orang lain.\n6. Tidak masuk ke sistem layanan pengguna perusahaan kami atau jaringan tanpa otorisasi.\n7. Tidak mengirimkan atau mendistribusikan virus komputer atau data lain yang dapat mengganggu atau merusak sistem komputer.\n8. Tidak melakukan tindakan komersil atau transaksi tanpa izin sebelumnya dari perusahaan kami.\n9. Tidak terlibat dalam transaksi ilegal, atau memposting informasi yang palsu dan menyesatkan.\n10. Tidak menjual senjata api, senjata tajam, narkoba, obat terlarang, perangkat lunak bajakan, atau barang lain yang dilarang oleh hukum.\n11. Tidak mengganggu pengguna lain atau pihak ketiga.\n12. Tidak menyediakan informasi judi atau dengan cara lain mendorong orang lain untuk berpartisipasi dalam judi.\n13. Tidak mengganggu atau menghentikan server yang menyediakan layanan terkait platform atau jaringan yang terhubung ke platform.\n\nDan masih banyak lagi poin-poin yang tidak saya sebutkan. Mohon maaf jika penerjemahan ini memakan banyak waktu, karena dokumen yang Anda berikan cukup panjang dan membutuhkan pemahaman yang mendalam untuk diterjemahkan dengan tepat.\n（2） Tanggung Jawab Penggunaan Platform oleh Pengguna:\n\nJika Perusahaan kami menilai Anda melanggar aturan yang telah ditetapkan atau berpotensi melanggar, kami memiliki hak untuk segera menghentikan atau mengubah hak akun Anda atau mengambil tindakan hukum yang sesuai, termasuk tetapi tidak terbatas pada membekukan akun, menghentikan layanan platform, pengembalian dana, menuntut kerugian, menahan atau menyimpan pembayaran transaksi Anda sampai klarifikasi, dan dapat menangani atau mentransfer dana ilegal Anda sesuai dengan keputusan atau perintah dari otoritas yang berwenang. Kami tidak bertanggung jawab atas tindakan tersebut kepada pengguna atau pihak ketiga.\n\nAnda harus bertanggung jawab atas semua aktivitas dalam akun Anda, termasuk konten apa pun yang Anda kirimkan, seperti teks, suara, gambar, video, dan lainnya. Anda harus memikul semua risiko yang timbul dari konten yang tidak pantas. Jika ada pelanggaran hukum, termasuk tetapi tidak terbatas pada pelanggaran hak kekayaan intelektual Perusahaan atau pihak ketiga, Anda harus bertanggung jawab atas konsekuensi hukumnya.\n\nJika Perusahaan kami menilai Anda melanggar aturan yang telah ditetapkan atau berpotensi melanggar, dan menyebabkan kerugian, biaya (termasuk tetapi tidak terbatas pada biaya administrasi, biaya pengacara, dll.), Denda pemerintah atau tuntutan dari pihak ketiga, Anda harus membayar ganti rugi penuh kepada kami. Jika Anda dapat membuktikan bahwa kerugian tersebut bukan karena kesalahan Anda dan kami memverifikasinya, kerugian tersebut akan dibagi antara kami.\n\nKonten apa pun yang Anda kirimkan melalui platform ini tidak mencerminkan pandangan atau kebijakan Perusahaan kami, dan kami tidak bertanggung jawab atasnya.\n\nKebijakan Privasi\nKami sangat menghargai privasi Anda dan ingin menjelaskan kebijakan privasi platform ini untuk melindungi hak Anda. Harap perhatikan konten berikut:\n（1） Ruang Lingkup Kebijakan Privasi: Data identifikasi pribadi yang dikumpulkan oleh perusahaan kami ketika Anda menggunakan layanan platform. Namun, ini tidak berlaku untuk tautan lain di luar platform ini atau staf yang bukan merupakan bagian dari perusahaan atau manajemen kami.\n（2） Tujuan dan Jenis Pengumpulan Data Pribadi:\n\nKetika Anda mengunjungi platform kami atau menggunakan layanan yang disediakan, kami mungkin meminta Anda untuk memberikan informasi pribadi yang diperlukan. Kami hanya akan memproses dan menggunakan data pribadi Anda dalam batas tujuan tertentu. Tanpa persetujuan tertulis Anda atau kesepakatan lain, kami tidak akan menggunakan data pribadi untuk tujuan lain. Anda dapat memilih untuk tidak memberikan informasi pribadi yang diperlukan, tetapi mungkin Anda tidak dapat menggunakan layanan platform ini.\n\nSaat browsing biasa, server akan merekam aktivitas terkait, termasuk alamat IP perangkat yang Anda gunakan, waktu penggunaan, data yang Anda klik, jenis browser, jenis perangkat seluler, informasi lokasi, dll. untuk meningkatkan layanan platform kami. Anda dapat memilih untuk menonaktifkan fitur pencatatan server, tetapi mungkin Anda tidak dapat menggunakan layanan platform ini.\n\nSaya akan berhenti di sini karena teksnya panjang. Jika Anda ingin melanjutkan penerjemahan, beri tahu saya!\n(7) Perubahan pada Ketentuan Privasi:\n\nKetentuan privasi platform ini mungkin akan dimodifikasi sesuai kebutuhan dari waktu ke waktu. Ketentuan yang telah dimodifikasi akan diberitahukan kepada pengguna melalui aplikasi. Perubahan akan mengikuti hukum Republik Cina. Jika Anda tidak setuju dengan perubahan tersebut, Anda dapat berhenti menggunakan platform ini kapan saja. Jika Anda terus menggunakan, berarti Anda setuju dengan perubahan tersebut.\n\nJika Anda memiliki pertanyaan tentang ketentuan privasi platform ini, atau ingin meminta akses, salinan, tambahan, koreksi, tinjauan, atau menghentikan pengumpulan dan menghapus data pribadi Anda, silahkan hubungi tim layanan pelanggan platform ini.\n\nTautan dan Konten Situs Pihak Ketiga:\n(1) Anda mengerti bahwa platform ini mungkin menampilkan iklan video dan mengarahkan ke situs web pihak ketiga, atau menyalin konten dari situs web pihak ketiga yang sudah menyebutkan sumbernya.\n(2) Namun, situs web pihak ketiga tidak termasuk dalam cakupan tanggung jawab perjanjian ini. Anda harus menilai kebenaran kontennya sendiri, dan perusahaan kami tidak bertanggung jawab atas kebenarannya.\n(3) Anda setuju bahwa perusahaan kami tidak bertanggung jawab atas kerugian yang mungkin Anda alami saat mengakses situs web pihak ketiga tersebut.\n\nPerilaku Pengguna dan Otorisasi:\n(1) Semua data yang Anda unggah, masukkan, atau berikan ke platform ini (termasuk hak kekayaan intelektual Anda) menunjukkan bahwa Anda telah memberikan izin kepada perusahaan kami untuk menggunakannya, mengubahnya, mendistribusikannya, menduplikasinya, atau menampilkannya untuk tujuan pemasaran, statistik, peningkatan bisnis, dan promosi layanan.\n(2) Anda juga menjamin bahwa penggunaan, modifikasi, distribusi, duplikasi, atau tampilan data oleh platform ini tidak melanggar hak pihak ketiga mana pun. Jika terjadi pelanggaran, Anda harus bertanggung jawab atas kerugian yang dialami oleh perusahaan kami.\n\nHak Kekayaan Intelektual:\n(1) Kecuali hak kekayaan intelektual dari "permainan" di platform ini yang dimiliki oleh perusahaan game asli dan hak kekayaan intelektual dari iklan yang ditempatkan oleh pihak ketiga dimiliki oleh pengiklan tersebut, semua program, perangkat lunak, dan konten situs web yang digunakan oleh platform ini, termasuk tetapi tidak terbatas pada: informasi, data, gambar, susunan layar, nama layanan, struktur situs web, desain halaman, dan konten pengguna, termasuk tetapi tidak terbatas pada hak paten, hak cipta, hak dagang, dan rahasia dagang, adalah milik perusahaan kami. Tidak ada yang dapat mengubah, menduplikasi, mendistribusikan, menerbitkan, menampilkan, melakukan reverse engineering atau dekompilasi tanpa izin tertulis dari perusahaan kami.\n(2) Grafik, teks, atau kombinasinya, serta logo dan nama produk atau layanan lainnya "nicee" (disebut "Tanda nicee") yang digunakan di layanan terkait adalah hak cipta atau merek dagang milik perusahaan kami. Tanpa persetujuan tertulis sebelumnya dari perusahaan kami, tidak ada yang dapat menggunakan "Tanda nicee" dengan cara apa pun.\n\nGangguan atau Kegagalan Layanan:\n(1) Layanan yang disediakan oleh platform ini mungkin akan mengalami gangguan atau kegagalan. Anda harus mengambil tindakan pencegahan saat menggunakan layanan ini.\n(2) Perusahaan kami tidak bertanggung jawab atas kerugian yang Anda alami karena menggunakan (atau tidak dapat menggunakan) layanan ini. Perusahaan kami berhak menghentikan atau mengganggu layanan jika terjadi salah satu dari kondisi berikut. Untuk kerugian, ketidaknyamanan, atau kerusakan yang mungkin timbul, perusahaan kami tidak bertanggung jawab kepada anggota atau pihak ketiga:\n\nPemeliharaan dan konstruksi peralatan perangkat lunak dan perangkat komunikasi elektronik terkait platform ini.\n\nKegagalan mendadak peralatan perangkat lunak dan komunikasi elektronik.\n\nDalam situasi darurat untuk melindungi properti dan keselamatan anggota lain atau pihak ketiga.\n\nKesalahan perangkat lunak, virus, trojan, atau program serupa yang mungkin ditransmisikan oleh pihak ketiga melalui platform ini dan layanannya.\n\nFaktor kekuatan majeur seperti bencana alam.\n\nPenafian:\n(1) Anda memahami bahwa perusahaan kami menyediakan layanan terkait platform ini sesuai dengan teknologi dan kondisi saat ini. Namun, kami tidak dapat selalu memprediksi risiko hukum, teknologi, dan lainnya. Jika risiko tersebut muncul, perusahaan kami akan berusaha memperbaikinya secepat mungkin, tetapi tidak bertanggung jawab atas kesalahan, keterlambatan, atau kelalaian data apa pun dari platform ini dan layanannya.\n(2) Perusahaan kami tidak memberikan jaminan apa pun untuk layanan di platform ini dan berhak menyesuaikan konten layanan sesuai perkembangan bisnis. Kerugian yang mungkin Anda alami karena penyesuaian konten layanan, perusahaan kami tidak bertanggung jawab.\n(3) Selain itu, Anda bertanggung jawab atas kerugian atau kerusakan apa pun yang mungkin Anda alami karena melanggar perjanjian ini. Perusahaan kami tidak bertanggung jawab atas ganti rugi apa pun.\n\nPemberitahuan:\n(1) Anda setuju bahwa perusahaan kami memiliki hak untuk mengubah, menghentikan sementara, atau menghentikan layanan ini (atau sebagian darinya) kapan saja tanpa pemberitahuan.\n(2) Metode pemberitahuan dari platform ini termasuk tetapi tidak terbat',
  first_recharge_bonus: 'Promo top up pertama（Batas Waktu）',
  new_user_special_offer: 'Spesial untuk pemula',
  pull_down_more: 'Tarik ke bawah untuk memanggil lebih banyak teman...',
  release_more: 'Lepaskan untuk memanggil lebih banyak teman',
  request_timeout: 'Permintaan timeout',
  voice_room_update_tip:
    'Untuk menggunakan fitur ruang suara dengan normal, silakan upgrade ke versi terbaru',
  voice_room_disabled_in_tip:
    'Anda telah dimasukkan ke ruang tersembunyi oleh admin, tidak dapat masuk',
  push: 'Dorong',
  coins: 'Koin',
  new_user_coupon_validity: 'Periode valid kupon spesial pemula tanpa syarat',
  share_to: 'Bagikan ke',
  account_belongs_nicee: 'Akun ini dimiliki oleh official nicee',
  fans: 'Penggemar',
  limited_time1: 'Hanya 1 koin untuk waktu terbatas',
  first_order_info: 'Pesanan pertama di platform, nikmati harga spesial',
  new_user: 'Pemula',
  discount_price: 'Diskon',
  new_user_coupon_discount: 'Kupon diskon untuk pemula',
  hesitant_try_a_7_minute_voice_chat_experience:
    'Ragu-ragu? Coba pengalaman chat suara 7 menit',
  this_user_account_has_been_deleted: 'Akun pengguna ini telah dihapus',
  post_a_dynamic: 'Posting dinamika',
  skill_information: 'Info keahlian',
  profile_info: 'Profil singkat',
  nickname: 'Nama',
  copy: 'Salin',
  age: 'Usia',
  gift_wall: 'Koleksi Hadiah',
  verification_level: 'Tingkat verifikasi',
  no_ratings_yet: 'Belum ada ulasan',
  user_repurchase: 'Pembelian ulang pengguna',
  online_response_time: 'Tingkat respons instan saat online',
  service_count: 'Jumlah layanan',
  gift_ranking: 'Daftar hadiah',
  connect: 'Terhubung',
  unblock: 'Buka blokir',
  she: 'Dia (perempuan)',
  he: 'Dia (laki-laki)',
  you_have_taken_this_skill_offline_quickly_go_to_skill_management_to_put_it_online:
    'Anda telah menonaktifkan keahlian ini, segera aktifkan kembali di manajemen keahlian',
  this_booster_has_taken_this_skill_offline_quickly_contact_them_to_put_it_online:
    'Pembimbing ini telah menonaktifkan keahliannya, segera hubungi untuk mengaktifkannya lagi!',
  user_not_found: 'Pengguna tidak ditemukan',
  wow_its_so_empty_here: 'Wah, sangat sepi di sini',
  no_orders_yet: 'Belum ada pesanan',
  no_gifts_received_yet: 'Belum ada hadiah yang dikirim',
  be_the_first_one_to_place_an_order_for_xxx:
    'Jadilah orang pertama yang memesan untuk menjaga',
  be_the_first_one_to_send_xxx_a_gift:
    'Jadilah orang pertama yang memberi hadiah kepada',
  file_generation_in_progress: 'Sedang membuat file',
  come_to_nicee_and_find_xxx_to_play_games:
    'Datang ke nicee, bermain game dengan xxx',
  your_understanding_teammates_are_here:
    'Teman tim yang mengerti Anda ada di sini',
  invite_you_to_play: 'Mengundang Anda untuk bermain',
  great_teammates_to_play_games_with_you:
    'nicee, teman baik bermain game dengan Anda',
  are_you_sure_you_want_to_unfollow:
    'Apakah Anda ingin membatalkan ikuti {msg}?',
  think_again: 'Pikirkan lagi',
  unfollow: 'Batalkan ikuti',
  just_online: 'Baru saja online',
  online: 'Online',
  you_have_blocked_the_other_party_please_unblock_and_try_again:
    'Anda telah memblokir orang ini, buka blokir sebelum mencoba lagi',
  the_current_version_does_not_support_this_feature_please_update_the_app_version_and_try_again:
    'Versi Anda saat ini tidak mendukung fitur ini, silakan perbarui versi aplikasi untuk menggunakannya',
  id_copied_successfully: 'ID telah disalin',
  switching: 'Pindah...',
  release_to_switch_to_the_gaming_companion_panel:
    'Lepaskan untuk beralih ke panel pembimbing',
  release_to_switch_to_the_user_panel:
    'Lepaskan untuk beralih ke panel pengguna',
  copied_uuid: 'UUID telah disalin',
  obtain_limited_avatar_frames_and_cash:
    'Dapatkan frame avatar eksklusif dan uang tunai',
  language_settings: 'Pengaturan bahasa',
  order_records: 'Catatan pesanan',
  skill_management: 'Manajemen skill',
  my_earnings: 'Penghasilan saya',
  'self-promotion_settings': 'Pengaturan promosi sendiri',
  view_detailed_data: 'Lihat data rinci',
  to_be_improved: 'Perlu ditingkatkan',
  good: 'Bagus',
  excellent: 'Luar biasa',
  all_data: 'Semua data',
  explanation_response_rate1:
    'Kualitas layanan yang lebih tinggi berarti lebih banyak pelanggan baru yang melakukan pesanan kedua, meningkatkan tingkat pembelian ulang Anda!',
  explanation_response_rate3:
    'Tingkat pembelian ulang Anda masih bisa ditingkatkan, terus berusaha!',
  explanation_response_rate4: 'Performa layanan Anda bagus, terus berusaha!',
  explanation_response_rate5:
    'Performa layanan Anda luar biasa, terus pertahankan!',
  explanation_response_rate6:
    'Belum menerima pesanan baru-baru ini, ayo semangat!',
  explanation_response_rate7:
    'Kualitas layanan yang lebih tinggi berarti jumlah pesanan pembelian ulang yang lebih besar, meningkatkan data Anda!',
  explanation_response_rate8:
    'Data Anda di bawah rata-rata platform, ayo berusaha!',
  explanation_response_rate9:
    'Data Anda masih bisa ditingkatkan, terus berusaha!',
  explanation_response_rate10: 'Performa layanan Anda bagus, terus berusaha!',
  explanation_response_rate11:
    'Performa layanan Anda luar biasa, terus pertahankan!',
  explanation_response_rate12: 'Belum ada pembelian ulang baru-baru ini~',
  explanation_response_rate13:
    'Merespons pesan pengguna dalam 1 menit dapat efektif meningkatkan indikator ini!',
  explanation_response_rate14:
    'Saat dalam status siap menerima pesanan, respons Anda dalam 1 menit rendah, ini akan mempengaruhi eksposur dan penerimaan pesanan Anda.',
  explanation_response_rate15:
    'Saat dalam status siap menerima pesanan, respons Anda tepat waktu, terus berusaha!',
  explanation_response_rate16:
    'Saat dalam status siap menerima pesanan, respons Anda sangat cepat, terus pertahankan!',
  explanation_response_rate17:
    'Belum memulai atau menerima percakapan baru-baru ini~',
  explanation_response_rate18:
    'Mendapatkan ulasan bintang 5 dengan lebih dari 5 kata dapat dengan cepat meningkatkan tingkat ulasan positif yang efektif!',
  explanation_response_rate19:
    'Pengguna sering memberi Anda ulasan positif, terus ber',
  explanation_response_rate20:
    'Pujian untuk layanan Anda luar biasa, terus pertahankan!',
  explanation_response_rate21: 'Belum menerima ulasan baru-baru ini.',
  explanation_response_rate22:
    'Karena Anda tidak merespons pesan pengguna atau tidak segera menerima pesanan, sistem telah menonaktifkan status dapat menerima pesanan Anda, tidak dapat diaktifkan dalam waktu 5 menit, silakan coba lagi nanti.',
  current_value: 'Nilai saat ini',
  current_index: 'Indeks saat ini',
  certificate_of_this_photo1:
    'Harap dicatat, verifikasi foto ini hanya memastikan foto pengguna adalah orang asli, masih ada kemungkinan foto profil tidak cocok dengan pengguna.',
  certificate_of_this_photo2:
    'Foto hanya untuk penggunaan sosial di nicee, tidak untuk keperluan lain.',
  certificate_of_this_photo3:
    'Mengganti foto profil akan menyebabkan verifikasi tidak valid, pengguna perlu melakukan verifikasi ulang.',
  certificate_of_this_photo4:
    'Dapat diverifikasi hingga 3 kali per minggu, setiap Senin jumlah pengajuan direset.',
  certificate_of_this_photo5: 'Anda telah lulus verifikasi foto.',
  certificate_of_this_photo6: 'Menikmati hak istimewa.',
  certificate_of_this_photo7: 'Telah lulus verifikasi foto.',
  certificate_of_this_photo8: 'Foto profil dikonfirmasi sebagai diri sendiri.',
  verify_now: 'Verifikasi sekarang.',
  under_review: 'Dalam ditinjau',
  certificate_of_this_photo9:
    'Hasil verifikasi akan diumumkan dalam waktu 10 menit.',
  failed_photo_verification: 'Belum lulus verifikasi foto.',
  certificate_of_this_photo10:
    'Limit pengajuan telah tercapai untuk minggu ini, dapat mengajukan lagi pada hari Senin depan.',
  photo_verification_rules: 'Aturan verifikasi foto.',
  rules_for_accepting_orders1:
    'Aturan penerimaan pesanan saat ini dan penjelasan.',
  rules_for_accepting_orders2:
    'Mengaktifkan tombol ini berarti Anda saat ini dapat menerima pesanan.',
  rules_for_accepting_orders3:
    'Jika tombol "Dapat Menerima Pesanan" diaktifkan, berarti Anda saat ini dapat menerima pesanan. Jika Anda melakukan tindakan berikut, sistem akan secara otomatis menonaktifkan status dapat menerima pesanan:',
  rules_for_accepting_orders4:
    'Anda tidak merespons pesan dari orang lain pada hari yang sama dalam waktu 1 menit.',
  rules_for_accepting_orders5:
    'Ingat: Jika Anda menemukan pengguna yang melakukan pelanggaran, silakan langsung blokir atau laporkan. Memblokir pengguna tidak akan mempengaruhi status online.',
  rules_for_accepting_orders6: 'Tidak menerima pesanan lebih dari 10 menit .',
  rules_for_accepting_orders7:
    'Ingat: Membuat pengguna menunggu terlalu lama bukanlah pengalaman bermain yang baik.',
  rules_for_accepting_orders8:
    'Harap diperhatikan: Jika status dapat menerima pesanan Anda dinonaktifkan oleh sistem, maka Anda tidak akan dapat mengaktifkannya lagi untuk sementara waktu, harap berhati-hati.',
  skill_add1: 'Belum menambahkan keahlian yang sering digunakan.',
  skill_add2: 'Pergi untuk menambahkan.',
  skill_add3: 'Dapat menambahkan hingga 30 kategori yang sering digunakan.',
  skill_add4: 'Ditambahkan sebagai keahlian yang sering digunakan.',
  skill_add5: 'Games Komputer',
  skill_add6: 'Games Konsol',
  skill_add7: 'Chatting Suara',
  skill_add8: 'Skills lainnya',
  home_ranking1:
    'Berdasarkan jumlah total pesanan yang diselesaikan oleh pembimbing permainan setiap hari.',
  home_ranking2: 'Setiap hari pukul 00:00:00 direset.',
  home_ranking3: 'Data pembaruan daftar setiap hari pukul 00:05:00.',
  home_ranking4: 'Gelar eksklusif *1 hari.',
  home_ranking5:
    'Berdasarkan jumlah total pesanan yang diselesaikan oleh pembimbing permainan setiap minggu.',
  home_ranking6: 'Minggu direset pada pukul 00:00:00.',
  home_ranking7:
    'Data pembaruan daftar dipamerkan setiap Senin pukul 23:59:59.',
  home_ranking8: 'Gelar eksklusif *1 minggu.',
  home_ranking9:
    'Daftar keahlian tunggal di puncak selama 1 hari. Setiap Selasa layanan pelanggan akan menanyakan tentang keinginan pembimbing untuk berada di puncak.',
  home_ranking10:
    'Berdasarkan jumlah total pesanan yang diselesaikan oleh pembimbing permainan baru setiap hari.',
  home_ranking11:
    'Definisi pembimbing permainan baru: Pembimbing yang bergabung dalam 30 hari terakhir hingga pukul 00:00:00 hari itu.',
  home_ranking12:
    'Berdasarkan jumlah total pesanan yang diselesaikan oleh pembimbing permainan baru setiap minggu.',
  home_ranking13:
    'Definisi pembimbing permainan baru: Pembimbing yang bergabung dalam 30 hari terakhir hingga Senin pukul 00:00:00 minggu itu.',
  home_ranking14: 'Daftar keahlian tunggal di puncak selama 2 jam *3 hari.',
  home_ranking15:
    'Berdasarkan jumlah total hadiah yang diterima oleh pembimbing permainan setiap hari.',
  home_ranking16:
    'Berdasarkan jumlah total hadiah yang diterima oleh pembimbing permainan setiap minggu.',
  home_ranking17:
    'Anda berhasil mendaftar untuk mendapatkan hadiah ketika mencapai jumlah tertentu\nAjukan untuk mengajar',
  home_ranking18:
    'Aturan penggunaan platform berdasarkan total jumlah pesanan yang dikonfirmasi selesai oleh pengguna platform setiap hari\nAturan berdasarkan total jumlah pesanan yang dikonfirmasi selesai oleh pengguna platform setiap minggu',
  home_ranking19: 'Frame profil eksklusif selama 1 minggu',
  home_ranking20:
    'Aturan berdasarkan total jumlah pesanan hadiah yang dikirim oleh pengguna platform setiap hari',
  home_ranking21:
    'Aturan berdasarkan total jumlah pesanan hadiah yang dikirim oleh pengguna platform setiap minggu',
  home_ranking22: 'Bingkai pesan eksklusif selama 1 minggu',
  no_one_here_at_the_moment: 'Saat ini belum ada orang',
  ranking_list_submit: 'Mengirim',
  contribution_points: 'Nilai kontribusi',
  data_updated_every_monday_night_at_2400:
    'Data diperbarui setiap Senin malam pukul 24:00',
  ranking_list_my: 'Saya',
  congratulations_you_are_currently_ranked_first:
    'Selamat, Anda saat ini berada di peringkat pertama',
  no_gifts_sent_yet: 'Belum mengirim hadiah',
  still_need_msg_to_catch_up_with_the_previous_rank:
    'Jarak ke peringkat di atas',
  send_a_gift: 'Mengirim hadiah',
  overall_leaderboard: 'Peringkat total',
  network_anomaly: 'Gangguan jaringan',
  please_enter_a_nickname_ID_game_skill:
    'Silakan masukkan nama panggilan/ID/keterampilan game',
  clear_search_history: 'Hapus riwayat pencarian',
  related_skills: 'Keterampilan terkait',
  freelance_skills_marketplace: 'Pasar keterampilan bebas',
  related_users: 'Pengguna terkait',
  sorry_no_content_related_to_msg_found:
    'Maaf, tidak ditemukan konten terkait {msg}',
  pull_down_to_summon_more_updates:
    'Tarik ke bawah untuk memanggil lebih banyak dinamika...',
  release_to_summon_more_updates:
    'Lepaskan untuk memanggil lebih banyak dinamika...',
  dynamic_deleted_successfully: 'Dinamika berhasil dihapus',
  coins_game: 'Koin per game',
  people_like_this: '{msg}orang menyukai',
  reply_msg: 'Balasan',
  write_a_message: 'Nulis komentar',
  maximum_200_characters_allowed: 'Maksimal 200 karakter',
  reply: 'Balas',
  delete: 'Hapus',
  expand_reply: 'Memperluas balasan',
  collapse_reply: 'Menyembunyikan',
  wow_its_empty_here: 'Wah, kosong sekali',
  follow_a_boosting_specialist_to_see_their_updates:
    'Ikuti pembimbing game untuk melihat dinamika!',
  express_matchmaking: 'Pesan cepat',
  find_boss: 'Temukan bos',
  cancel_order: 'Membatalkan pesanan',
  what_is_the_reason_for_canceling_your_order:
    'Alasan pembatalan pesanan Anda adalah apa?',
  canceling_multiple_times_will_affect_future_orders:
    'Pembatalan berulang dapat mempengaruhi pesanan di masa depan',
  please_enter_the_reason: 'Silakan masukkan alasan...',
  experimental_operation: 'Operasi percobaan',
  too_few_available_game_coaches: 'Kurangnya pembimbing game yang tersedia',
  unable_to_find_a_satisfactory_game_coach:
    'Tidak menemukan pembimbing game yang memuaskan',
  incorrect_order_details: 'Kesalahan dalam mengisi detail pesanan',
  other_reasons: 'Alasan lain',
  this_order_has_been_canceled: 'Pesanan ini telah dibatalkan',
  completed_tutorial: 'Pembelajaran yang telah diselesaikan',
  order_completed: 'Selesai',
  order_conditions: 'Kondisi pesanan',
  successfully_matched_with_a_game_coach: 'Berhasil mencocokkan teman',
  a_total_of: 'Total',
  game_coaches_are_available_for_order:
    'Pembimbing game yang bersaing untuk pesanan',
  accepted_msg_times: 'Menerima {msg} kali pesanan',
  msg_repurchase_rate: '{msg}% pembelian ulang',
  express_tutorial: 'Pembelajaran cepat',
  place_an_order: 'Saya ingin memesan',
  notification_settings: 'Pengaturan notifikasi',
  only_retain_the_latest_10_order_records:
    'Hanya menyimpan 10 catatan pesanan terakhir',
  you_already_have_an_ongoing_order:
    'Anda sudah memiliki pesanan yang sedang berlangsung',
  guaranteed_rank_boost: 'Peringkat dijamin menang',
  experience_order: 'Pesanan pengalaman',
  'one-click_order': 'Pemesanan cepat dengan satu klik',
  'text-based_order': 'Pemesanan cepat dengan teks',
  'voice-based_order_only': 'Hanya pemesanan cepat dengan suara',
  'voice-based_order': 'Pemesanan cepat dengan suara',
  'one-click_order_use_voice_commands_to_place_an_order':
    'Pemesanan cepat dengan satu klik: Kirim suara keterampilan yang ada untuk pemesanan cepat.',
  already_claimed: 'Telah dipesan',
  providing_detailed_introductions_increases_the_chances_of_getting_orders:
    'Perkenalan yang kaya akan membuat Anda lebih mudah mendapatkan pesanan',
  order_card_info1:
    'Misalnya: "Halo, saya sangat pandai berbicara, karakter favorit saya adalah Janna, bisa jadi pendukung eksklusif Anda"(5～25 karakter)',
  order_card_info2:
    'Peringatan: Kencan seksual dilarang keras, pelanggaran akan dikenai sanksi berat',
  confirm_order_claim: 'Konfirmasi pemesanan',
  no_restrictions: 'Semua',
  today: 'Hari ini',
  msg_month_msg2_day: 'Tanggal {msg} bulan {msg2}',
  explanation_of_guaranteed_ein_order: 'Penjelasan pesanan "Menang Terjamin"',
  order_card_info3:
    '1. Pembimbing game harus memiliki akun game dengan peringkat yang sesuai untuk menerima pesanan\\n\\n2. Pesanan menang terjamin dihargai per kemenangan, harga dapat disesuaikan berdasarkan peringkat, silakan berikan penawaran saat pemesanan\\n\\n3. Dengan menekan setuju, pembimbing game setuju untuk mencapai kesepakatan dengan pengguna tentang jumlah kemenangan bersih yang dinegosiasikan',
  agree: 'Setuju',
  order_card_info4:
    'Tingkat verifikasi League of Legends Anda tidak memenuhi persyaratan, silakan tingkatkan level Anda sebelum pemesanan',
  an_error_occurred_please_refresh_the_page_and_try_again:
    'Terjadi kesalahan, silakan',
  the_order_claim_mode_is_not_suitable:
    'Mode pesanan cepat tidak memenuhi syarat',
  order_card_info5:
    'Saat ini belum menetapkan jumlah untuk mode "{msg}", silakan atur sebelum mencoba pesanan cepat',
  go_to_settings: 'Pergi ke pengaturan',
  no_mode_restrictions: 'Mode tidak terbatas',
  the_order_pricing_unit_does_not_meet_the_requirements:
    'Unit harga pesanan cepat tidak memenuhi syarat',
  order_card_info6:
    'Saat ini belum menetapkan jumlah untuk unit harga "{msg}", silakan atur sebelum mencoba pesanan cepat',
  your_price_exceeds_the_order_requirements:
    'Harga Anda melebihi persyaratan pesanan',
  order_card_info7:
    'Harga Anda terlalu tinggi, apakah Anda ingin menurunkan harga untuk pesanan cepat ini? Kami akan menyesuaikan harga pesanan cepat ini menjadi {msg}, tidak mempengaruhi harga pesanan normal',
  lower_price_and_claim_order: 'Turunkan harga pesanan cepat',
  cancel_order_claim: 'Batalkan pesanan cepat',
  order_card_info8:
    'Atur waktu bangun menjadi {msg}, silakan konfirmasi apakah Anda setuju dengan pesanan cepat?',
  confirm: 'Konfirmasi',
  if_you_reach_the_elite_rank: 'Jika Anda mencapai Elite',
  if_you_reach_the_eternal_legend_rank: 'Jika Anda mencapai Legend abadi',
  order_card_info9:
    'Saat ini pesanan menang terjamin berlaku sistem undangan, {msg}, silakan siapkan bukti terkait dan hubungi asisten layanan pelanggan untuk aplikasi.',
  order_card_info10:
    'Rank Anda belum mencapai "Elite"/"Legend abadi", silakan verifikasi setelah mencapainya',
  order_card_info11:
    'Teks berulang terlalu banyak, perkenalan yang kaya dapat meningkatkan kesempatan dipilih',
  order_card_info12:
    'Selamat bergabung dalam antrian pesanan cepat! Skor komprehensif meningkat!!',
  i_want_to_schedule_an_order: 'Saya ingin memesan',
  'limited-time_offer_for_first-time_customers':
    'Penawaran terbatas untuk pesanan pertama pemula!',
  remaining: 'Sisa',
  what_kind_of_msg_are_you_looking_for: 'Apa yang Anda cari?',
  coach: 'Pelatih',
  order_scheduling_available_from: 'Waktu buka pesanan',
  early_morning: 'Dini hari',
  looking_for_coaching: 'Mencari pelajaran',
  please_select_your_coaching_requirements:
    'Silakan pilih kebutuhan pelajaran Anda',
  please_select_coaching_mode: 'Silakan pilih mode pelajaran',
  mode: 'Mode',
  your_rank: 'Rank Anda',
  rank: 'Rank',
  please_select_your_current_rank: 'Silakan pilih rank saat ini Anda',
  time: 'Waktu',
  select_time: 'Pilih waktu',
  select_msg: 'Pilih {msg}',
  voice_recording_is_required_when_securing_an_order:
    'Teman perlu merekam suara saat mengambil orderan',
  order_card_info13:
    'Anda dapat memasukkan kebutuhan khusus Anda, memposting konten seksual, mencaci maki, iklan dll akan menghadapi hukuman blokir',
  please_confirm_your_order_requirements:
    'Silakan konfirmasi permintaan orderan Anda',
  confirm_order: 'Konfirmasi orderan',
  order_card_info14:
    'Waktu memilih adalah 15 menit, pembatalan melebihi waktu mungkin akan dikenakan kompensasi $5~$10 untuk teman',
  days: 'Hari',
  coaching_tier: 'Tingkat pelajaran',
  price: 'Harga per unit',
  mode_unlimited: 'Mode tidak terbatas',
  rank_no_restriction: 'Rank tidak terbatas',
  order_card_info15:
    'Untuk memastikan pengalaman pesanan Anda, pastikan saldo akun cukup sebelum memesan - Saldo saat ini:',
  insufficient_balance: 'Saldo tidak cukup',
  got_it: 'Saya mengerti',
  please_select_the_number_of_orders: 'Silakan pilih jumlah pesanan',
  order_card_info16:
    'Server sedikit bermasalah, insinyur kami sedang berusaha memperbaikinya',
  please_select_your_rank: 'Silakan pilih rank Anda',
  elite: 'Elite',
  order_card_info17:
    '1. Pesanan menang terjamin akan dikirim ke semua pelatih "{msg}" di platform\\n\\n2. Harga berdasarkan per kemenangan, harga spesifik terkait dengan rank, silakan negosiasi dengan pelatih\\n\\n3. Pelatih tidak mendukung pilihan jenis kelamin',
  guaranteed_win_order_explanation: 'Penjelasan pesanan menang terjamin',
  insufficient_account_balance: 'Saldo akun tidak cukup',
  i_want_to_recharge: 'Top Up',
  current_balance: 'Jumlah saat ini',
  order_notification_settings: 'Pengaturan notifikasi orderan cepat',
  order_notification: 'Notifikasi orderan cepat',
  select_coach: 'Pilih pelatih',
  select_booster: 'Pilih teman',
  countdown: 'Hitung mundur',
  my_orders: 'Pesanan saya',
  order_requirements: 'Permintaan orderan',
  the_booster_is_on_the_way_please_wait:
    'Teman sedang dalam perjalanan, silakan tunggu...',
  the_booster_is_on_the_way: 'Teman dalam perjalanan...',
  see_more: 'Lihat lebih banyak',
  randomly_select_one: 'Pilih secara acak satu',
  the_maximum_number_of_boosters_available_for_order_has_been_reached_msg:
    'Jumlah teman yang bisa ikut pesanan cepat sudah mencapai batas maksimum ({msg} )',
  more_boosters_are_on_their_way: 'Lebih banyak teman dalam perjalanan...',
  no_more_available: 'Tidak ada lagi',
  buy_msg_get_msg_for_free: 'Dapatkan {msg2} setelah mengisi {msg}',
  apply_for_coaching: 'Ajukan bermain bersama',
  waiting_order_tip1: 'Pesanan Anda dibatalkan karena waktu habis',
  waiting_order_tip2:
    'Jumlah pembatalan harian melebihi batas, tidak bisa melakukan pesanan cepat lagi hari itu',
  waiting_order_tip3: 'Pesanan telah berakhir',
  waiting_order_tip4: 'Pesanan cepat dibatalkan karena waktu habis',
  waiting_order_tip5: 'Masih tersisa 30 detik, buru',
  hint: 'Peringatan',
  comment: 'Komentar',
  skill_category: 'Kategori keterampilan',
  tags: 'Tag',
  no_suitable_game_coaches_for_now: 'Tidak ada pelatih yang memenuhi syarat',
  online_priority: 'Prioritas online',
  order_quantity_priority: 'Prioritas jumlah pesanan',
  low_price_priority: 'Prioritas harga rendah',
  newcomer_priority: 'Prioritas pemula',
  female_only: 'Hanya wanita',
  male_only: 'Hanya pria',
  essential_for_ranking_up: 'Wajib naik level',
  profile_verification: 'Verifikasi foto asli',
  view_more: 'Lihat lebih banyak',
  accept_orders: 'Siap',
  times: 'Kali',
  'in-game_currency': 'Dalam mata uang',
  order_completion_king: 'Raja pesanan ulang',
  hours_ago: 'Jam yang lalu',
  minutes_ago: 'Menit yang lalu',
  celebration: 'Festival',
  korean_server_elite: 'Elite server Korea',
  '30_minutes': 'Setengah jam',
  hour: 'Jam',
  round: 'Permainan',
  victory: 'Kemenangan',
  day: 'Hari',
  '7_minutes': '7 menit',
  within: 'Dalam{msg}',
  verified: 'Terverifikasi',
  msg_points_higher_than_msg2: 'Skor {msg} (lebih tinggi dari {msg2}%)',
  limited_time_event_summer_carnival_giveaway: 'Promosi terbatas: Pesta Summer',
  top_up_amount: 'Jumlah Top Up',
  gift_msg_coins: 'Berikan{msg} koin',
  recharge_page_tip1:
    'Akun Anda saat ini ditangguhkan untuk membuat/mengisi ulang pesanan karena kredit yang tidak normal. Jika ada pertanyaan, silakan hubungi layanan pelanggan "nicee little housekeeper"',
  contact_immediately: 'Hubungi sekarang',
  your_version_is_too_old_please_upgrade_to_the_latest_version:
    'Versi Anda terlalu lama, harap perbarui ke versi terbaru',
  summer_carnival_giveaway: 'Pesta musim panas',
  top_up_nicee_coins: 'Isi ulang koin nicee',
  current_diamonds: 'Permata Saya',
  exchange_diamonds_with_gold_coins: 'Menukar koin dengan permata',
  exchange_rate: 'Rasio pertukaran',
  gold_coins_exchange_115: '1 koin untuk 15 diamon',
  purchase_diamonds: 'Beli permata',
  exchanging: 'Sedang ditukarkan...',
  exchange_successful: 'Penukaran berhasil',
  exchange_failed: 'Penukaran gagal',
  gift_msg_diamonds: 'Dapatkan {msg} diamon',
  credit_card: 'Kartu kredit',
  visamastercardunionpayamex: '(Visa/MasterCard/UnionPay/AmEx)',
  more: 'Lebih',
  email_address: 'Email',
  recharge_page_tip2:
    'Masukkan email untuk menerima notifikasi pembayaran dan faktur elektronik.',
  please_provide_the_payers_email_address: 'Silakan masukkan email pembayar',
  balance_of_heart: 'Saldo yang tersedia',
  recharge_page_tip3:
    'Akun Anda saat ini ditangguhkan untuk membuat/mengisi ulang pesanan karena kredit yang tidak normal. Untuk pertanyaan, silakan tambahkan "nicee little housekeeper" untuk konsultasi',
  recharge_page_tip4:
    'Akun Anda sementara tidak dapat melakukan isi ulang dan pesanan karena memicu kontrol risiko platform',
  system_abnormality: 'Kesalahan sistem',
  please_enter_your_email_address: 'Masukkan email Anda',
  incorrect_email_format: 'Format email tidak benar',
  purchase_successful: 'Pembelian berhasil',
  purchase_failed: 'Pembelian gagal',
  paypal_payment_failed: 'Pembayaran PayPal gagal',
  paypal_payment_canceled: 'Pembayaran PayPal dibatalkan',
  please_select_the_quantity_of_diamonds_to_purchase:
    'Pilih jumlah diamon yang akan dibeli',
  failed_to_create_order: 'Gagal membuat pesanan',
  failed_to_create_paypal_order: 'Gagal membuat pesanan PayPal',
  payment_successful: 'Pembayaran berhasil',
  failed_to_obtain_paypal_authorization: 'Gagal mendapatkan otorisasi PayPal',
  due_to_triggering_platform_risk_control_your_account_is_temporarily_unable_to_top_up_and_place_orders:
    'Akun Anda sementara tidak dapat melakukan isi ulang dan pesanan karena memicu kontrol risiko platform',
  please_select_a_payment_method: 'Pilih metode pembayaran',
  currently_you_have_msg_candies: 'Permen Saya',
  candy_tip:
    'Permen dapat digunakan untuk undian, acara-acara ini sering diadakan, jadi nantikan terus ya!',
  ongoing_activities: 'Acara sekarang',
  past_activities: 'Acara sebelumnya',
  available_coupons: 'Kupon tersedia',
  pieces: 'Lembar',
  free_order: 'Gratis',
  available_on_orders_over_msg: 'Dapat digunakan dengan minimal {msg}',
  spend_msg_to_get_a_msg2_discount: 'Diskon {msg} untuk minimum {msg2}',
  valid: 'Aktif',
  occupied: 'Sedang digunakan',
  used: 'Telah digunakan',
  expired: 'Kadaluarsa',
  deleted: 'Dihapus',
  cancel_use: 'Batalkan penggunaan',
  use_now: 'Gunakan sekarang',
  valid_until: 'Berlaku hingga',
  coupons_bar_tip:
    'Ada banyak pelatih yang hebat dan menarik di platform, mengapa Anda tertarik padanya?',
  exclusive_coupon: 'Kupon eksklusif',
  can_only_be_used_for_the_referrer:
    'Hanya dapat digunakan untuk orang yang mengundang',
  how_to_get_more_orders: 'Cara mendapatkan lebih banyak pesanan',
  pull_down_to_refresh: 'Tarik ke bawah untuk menyegarkan',
  release_to_refresh: 'Lepaskan untuk menyegarkan',
  coupons_bar_tip2: 'Selamat, Anda telah memenangkan "Paket Kejutan Cinta"',
  coupons_bar_tip3: 'Konfirmasi pesanan selesai?',
  coupons_bar_tip4:
    'Setelah dikonfirmasi, uang akan ditransfer ke akun pelatih, dan Anda tidak akan dapat mengajukan pengembalian dana atau klaim purna jual lainnya, silakan beroperasi dengan hati-hati.',
  already_completed: 'Selesai',
  failed_to_open_red_envelope: 'Gagal membuka paket',
  coupons_bar_tip5:
    'Untuk menghindari sengketa, pastikan pesanan telah sepenuhnya selesai sebelum mengonfirmasi! Jika pengguna tidak mengonfirmasi setelah selesai, pesanan akan otomatis selesai dalam 3 hari. Setelah selesai, pesanan tidak dapat dibatalkan atau dikembalikan lagi',
  thats_all_for_now: 'Itu saja~',
  i_havent_checked_other_game_companions_yet: 'Belum melihat teman lainnya',
  coupon: 'Kupon',
  visit_msg_times: 'Kunjungan ke-{msg}',
  msg_days_ago: '{msg}hari yang lalu',
  invite_new_users_to_win_exclusive_prizes:
    'Undang baru untuk mendapatkan hadiah eksklusif',
  the_link_has_been_copied: 'Tautan berbagi telah disalin',
  invite_and_win: 'Undang baru untuk mendapatkan',
  exclusive_prize: 'Hadiah eksklusif',
  starting_from_msg_year_msg2_month_msg3:
    'Mulai dari {msg} tahun {msg2} bulan {msg3}',
  draw_once: 'Tarik sekali',
  msg_chances_remaining: 'Kesempatan tersisa {msg}',
  '10_draws_in_a_row': 'Tarik 10 kali sekaligus',
  the_invitation_code_has_been_copied: 'Kode undangan telah disalin',
  invite_new_users_to_get_a_limited_edition_avatar_frame_and_cash:
    'Undang pengguna baru untuk mendapatkan "Edisi Terbatas" frame avatar dan uang tunai!',
  invite_3_people_to_register_and_get_cyberpunk_2077_3_days:
    '1. Mengundang 3 orang registrasi mendapatkan Cyberpunk (3 hari)',
  invite_30_people_to_register_and_get_cyberpunk_2077_30_days:
    '2. Mengundang 30 orang registrasi mendapatkan Cyberpunk (30 hari)',
  apullc_tip:
    'Pengguna yang diundang bisa mendapatkan 1 undian berhadiah untuk setiap 100 koin yang disimpan dalam waktu 90 hari.dapat menarik cyberpunk (permanen) dan banyak uang.',
  preview_avatar_frame: 'Pratinjau frame avatar',
  apullc_tip2:
    'Catatan: Cashback dari pendamping akan masuk ke pendapatan dan cashback dari pengguna akan masuk ke dompet. Mungkin ada beberapa penundaan dalam kesempatan lotere dan pelepasan hadiah, mohon bersabar. Satu orang yang mendaftarkan lebih dari satu akun dengan menggunakan ponsel yang sama atau dengan cara lain, maka undangan yang diterima tidak valid.',
  special_support_program_for_streamers: 'Program dukungan khusus streamer',
  apullc_tip3:
    'Streamer Twitch, YouTube yang memasukkan kode undangan di channel mereka bisa mendapatkan hak khusus "ID Bahasa Inggris", mengundang pengguna juga bisa menikmati paket kupon khusus (nilai 150 koin)! Jika berpartisipasi dalam program ini, silahkan hubungi layanan pelanggan.',
  i_have_accumulated_cash_rewards:
    'Saya telah mendapatkan total hadiah uang tunai',
  msg_draws_msg2_times_msg3_obtained: '{msg} kali tarik mendapatkan {msg3}',
  msg_friends_registered: '{msg} teman {msg2} registrasi',
  msg_friends_bound_to_this_account_have_topped_up:
    'Teman yang terikat {msg} melakukan top up',
  i_am_registered_through_a_friends_invitation:
    'Saya diundang oleh teman untuk registrasi',
  bind_friend_invitation_code: 'Mengikat kode undangan teman',
  help_friends_get_drawing_chances:
    'Membantu teman mendapatkan kesempatan tarik',
  friend_invitation_code_has_been_bound: 'Kode undangan teman telah terikat',
  enter_friend_invitation_code: 'Mengisi kode undangan teman',
  please_enter_friend_invitation_code: 'Masukkan kode undangan teman',
  msg_coins: '{msg} koin',
  failed_to_draw: 'Tarik gagal',
  congratulations_on_winning: 'Selamat, Anda berhasil tarik',
  apullc_tip4:
    'Sebelum mengisi kode undangan, Anda perlu mengikat nomor ponsel akun saat ini',
  apullc_tip5: 'Selamat berhasil mengikat kode undangan teman',
  you_are_not_a_new_user: 'Anda bukan pengguna baru',
  close: 'Tutup',
  you_have_already_bound: 'Anda telah mengikat',
  settlement_details: 'Detail penyelesaian',
  including_repurchase_subsidy: 'Termasuk subsidi buyback',
  exchange: 'Tukar',
  gift: 'Beri',
  exchangeable_amount: 'Jumlah tukar',
  transfer_balance_tip:
    'Pendapatan 1:1 ditukar menjadi koin nicee，secara instan',
  transfer_balance_tip2:
    'Event musim panas terbatas dimulai! Dari 21 Juni sampai 19 Juli, menukar koin nicee bisa mendapatkan',
  additional_10_bonus: '10% ekstra bonus',
  enter_amount: 'Masukkan jumlah',
  please_enter_the_amount: 'Masukkan jumlah',
  exceeded_the_exchangeable_amount: 'Melebihi jumlah yang bisa ditukar',
  the_amount_cannot_be_0: 'Jumlah tidak bisa nol',
  transferring: 'Sedang ditransfer',
  confirm_exchange_of_msg_coins: 'Konfirmasi tukar',
  arrange: 'Atur',
  hold_and_drag_to_rearrange: 'Tekan dan geser untuk menyusun ulang',
  saved_successfully: 'Penyimpanan berhasil',
  skill_list_tip:
    'Karena Anda tidak segera membalas pesan pengguna atau menerima pesanan, status bisa menerima pesanan ditutup oleh sistem, tidak bisa dibuka dalam 5 menit, silakan coba lagi nanti',
  public: 'Publik',
  hide: 'Sembunyi',
  audit_not_passed_go_to_modify: 'Audit tidak lulus, silakan modifikasi',
  audit_passed: 'Audit lulus',
  please_complete_the_skill_information:
    'Silakan lengkapi informasi keterampilan',
  go_to_modify: 'Pergi untuk modifikasi',
  skill_card_tip:
    'Untuk menggunakan fungsi pengaturan keterampilan dengan normal, harap perbarui ke versi terbaru',
  skill_card_tip2:
    'Menghapus keterampilan akan menghapus informasi yang diisi, konfirmasi menghapus keterampilan ini?',
  confirm_deletion: 'Konfirmasi penghapusan',
  deletion_successful: 'Penghapusan berhasil',
  deletion_failed: 'Penghapusan gagal',
  skill_card_tip3:
    'Akun Anda terlibat dalam pelanggaran, penayangan keterampilan ditangguhkan, untuk detail silakan konsultasi dengan administrator',
  click_more_to_greet_with_one_click:
    'Klik lebih untuk menyapa dengan satu klik',
  all: 'Semua',
  chat_with_msg: 'Mencari {msg} untuk berbicara',
  new_to_the_platform: 'Pengguna baru platform',
  placed_an_order_msg_days_ago: '{msg} hari yang lalu membuat pesanan',
  msg_may_want_to_play_msg2: '{msg} mungkin ingin bermain: {msg2}',
  online_msg_hours_ago: 'Online{msg} jam yang lalu',
  select_content_to_send: 'Pilih konten yang akan dikirim',
  click_to_enter: 'Klik untuk memasukkan',
  hello_lets_play_if_you_want: 'Halo~ Jika ingin bermain, ajak saya ya',
  hello_boss_want_to_play_games: 'Boss, halo~ Main game yuk?',
  youre_here_ive_been_waiting_for_you_for_a_long_time:
    'Anda sudah datang~ Saya sudah menunggu Anda lama > <',
  custom: 'Kustomisasi',
  sent_successfully: 'Pengiriman berhasil',
  no_visitors_in_the_last_30_days:
    'Tidak ada pengunjung dalam 30 hari terakhir',
  save: 'Simpan',
  self_promotion_for_game_companions: 'Promosi diri pelatih',
  promotion_tips: 'Tips promosi',
  recommend_self_tip:
    'Menambahkan pelatih yang berhasil, keterampilan tertentu akan muncul di penawaran khusus pemula, mendapatkan lebih banyak eksposur, lebih banyak pesanan dari pengguna baru!',
  recommend_self_tip2:
    'Saat ini hanya diizinkan menambahkan satu keterampilan, hanya bisa diubah sekali dalam 12 jam',
  recommend_self_tip3:
    'Keterampilan ditutup karena tidak menerima pesanan dalam waktu, telah ditutup',
  closed: 'Ditutup',
  modify: 'Modifikasi',
  can_only_modify_the_skill_once_a_day:
    'Hanya bisa mengubah keterampilan sekali sehari',
  auto_reply: 'Balasan otomatis',
  recommend_self_tip4:
    'Menarik pelanggan baru dengan harga rendah, mendapatkan lebih banyak eksposur',
  enable_automatic_message_sending: 'Aktifkan pengiriman pesan otomatis',
  choose_a_skill: 'Pilih Skills',
  discount_offer: 'Diskon promosi',
  please_select_a_skill: 'Silakan pilih satu keterampilan',
  discounted_price: 'Harga setelah diskon: $',
  self_promotion_skill_description: 'Penjelasan keterampilan promosi diri',
  recommend_self_tip5:
    '1. Area khusus pemula hanya terlihat oleh pengguna yang baru terdaftar, setiap pengguna baru hanya bisa menggunakan harga promosi $25 sekali untuk memesan.',
  recommend_self_tip6:
    '2. Pelatih perlu membayar 50% biaya eksposur khusus, setiap pesanan pengalaman $40, pelatih akan mendapatkan pendapatan $20!',
  recommend_self_tip7:
    '3. Ingatlah untuk meninggalkan kesan pertama yang baik pada pengguna dalam pesanan promosi, setiap pengguna baru bisa menjadi pelanggan tetap Anda, jangan lewatkan kesempatan untuk mengeksplorasi sumber pelanggan baru.',
  recommend_self_tip8:
    '4. Pelatih hanya bisa mengajukan promosi diri sekali setiap 12 jam.',
  automatic_reply_description: 'Penjelasan balasan otomatis',
  recommend_self_tip9:
    '1. Ketika pengguna telah melihat halaman pelatih dan tertarik dengan pelatih tersebut, fungsi ini akan secara otomatis menyapa pengguna, setelah pengguna membalas akan memulai obrolan, janji temu, atau pesanan dengan pelatih.',
  recommend_self_tip10:
    '2. Setelah keterampilan promosi diri diaktifkan, fungsi pengiriman pesan otomatis akan diaktifkan. Pelatih bisa mengaktifkan atau menonaktifkan fungsi pengiriman pesan otomatis kapan saja.',
  please_select_a_discount_offer: 'Silakan pilih diskon promosi',
  enable: 'Aktifkan',
  can_be_enabled_after_2400_tonight:
    'Bisa diaktifkan setelah pukul 24.00 malam ini',
  disable_self_promotion_skill: 'Nonaktifkan keterampilan promosi diri',
  automatic_sending_field_cannot_be_empty:
    'Kolom pengiriman otomatis tidak boleh kosong',
  new_user_auto_greeting: 'Auto greet new users',
  new_user_auto_greeting_tip:
    'After a new user registers, Nicee will use this message to start a 1v1 chat.',
  new_user_auto_greeting_voice: 'Voice message',
  new_user_auto_greeting_limit:
    'Eligible hosts need score 1000+, online, and available for orders.',
  enable_new_user_auto_greeting: 'Enable auto greet',
  new_user_auto_greeting_empty: 'Please add text or a voice message.',
  submission_successful: 'Pengajuan berhasil',
  recommend_self_tip11:
    'Anda memiliki perubahan yang belum disimpan, konfirmasi untuk menyimpan?',
  confirm_save: 'Konfirmasi penyimpanan',
  recommend_self_tip12:
    'Setelah ditutup, keterampilan tersebut tidak akan muncul di penawaran khusus pemula, konfirmasi untuk menutup?',
  can_only_submit_once_a_day: 'Hanya bisa mengajukan sekali sehari',
  submission_failed: 'Pengajuan gagal',
  recommend_self_tip13:
    'Silakan tambahkan keterampilan sebelum mengaktifkan pengiriman otomatis',
  score3_explain_popup_tip:
    'Skor komprehensif yang lebih tinggi, alokasi eksposur yang lebih tinggi',
  how_to_improve_the_comprehensive_rating:
    'Bagaimana meningkatkan skor komprehensif?',
  service_attitude: 'Sikap layanan',
  score3_explain_popup_tip2:
    '1. Memesan beberapa kali menunjukkan kualitas pengalaman',
  score3_explain_popup_tip3:
    '2. Ulasan dari pemain adalah standar penting kualitas pengalaman',
  score3_explain_popup_tip4:
    '3. Jumlah pesanan adalah pengakuan kualitas pengalaman',
  service_quality: 'Kualitas layanan',
  score3_explain_popup_tip5:
    '1. Membalas segera adalah standar penting responsif',
  score3_explain_popup_tip6:
    '2. Jumlah penerimaan pesanan adalah penampilan penting responsif',
  score3_explain_popup_tip7: '3. Menghubungi pengguna yang telah melihat Anda',
  misconduct: 'Perilaku buruk',
  score3_explain_popup_tip8:
    'Jika Anda memiliki perilaku buruk, skor komprehensif Anda akan dikurangi',
  score3_explain_popup_tip9: '1. Tidak segera membalas pesan pengguna online',
  score3_explain_popup_tip10: '2. Mendapat ulasan negatif dari pemain',
  score3_explain_popup_tip11: '3. Dilaporkan terlibat pelanggaran',
  score3_explain_popup_tip12:
    'Skor komprehensif dihitung bersama setiap hari pukul 8 pagi, mungkin ada keterlambatan, harap bersabar.',
  membership_level: 'Level keanggotaan',
  you_have_exceeded_this_level: 'Anda telah melewati level ini',
  vip_center_tip:
    'Skor saat ini {msg}, masih memerlukan {msg2} poin untuk naik ke {msg3}',
  current_points_msg: 'Skor saat ini',
  claim_now: 'Ambil sekarang',
  score3_explain_popup_tip13:
    'Setelah diambil, skor akan berubah menjadi {msg}, dan level menjadi {msg2}',
  score3_explain_popup_tip14:
    '1. Melakukan pesanan atau memberikan hadiah setiap melakukan pembayaran 1 koin akan mendapatkan 1 poin member, poin dapat diakumulasikan, setelah level meningkat akan mendapatkan hadiah berdasarkan levelnya, hadiah dibagi sebagai 3 macam dibawah ini:',
  score3_explain_popup_tip15:
    '2. Kostum - Bingkat Foto, Bingkai kolom cat, Spanduk, berkuda duduk diperoleh secara real time dan berlaku secara permanen.',
  score3_explain_popup_tip16:
    'Kategori Preferensial - Voucher, berlian, dan harta karun tersedia untuk diambil dari tanggal 1 setiap bulan (setelah jam 9 pagi) hingga akhir bulan. Setelah menerimanya, itu akan memerlukan sejumlah poin (70% dari poin yang diperlukan untuk tingkat hadiah) dan memperbarui nilai; Jika Anda tidak mengambilnya, jumlah poin tidak akan berkurang',
  score3_explain_popup_tip17:
    'Kategori hak istimewa - Berlaku secara real time berdasarkan level saat ini.',
  example: '3 contoh:',
  score3_explain_popup_tip18:
    'Pada 30 Oktober, poinnya adalah 50.000, dan levelnya adalah VIP9. Lakukan pemesanan 10.000 koin pada tanggal 31, dapatkan 10.000 poin, berikan hadiah 10.000 koin (150.000 berlian) untuk mendapatkan 10.000 poin, kumpulkan total 70.000 poin dan tingkatkan ke VIP10, dan segera dapatkan hadiah perhiasan dan hak istimewa VIP10. Setelah jam 9 pagi pada tanggal 1 November, Anda dapat menerima hadiah preferensial VIP10: 10 kupon 50 koin dan 6.000 berlian. Jika Anda memilih untuk mengklaim, 70.000 poin akan dikurangi dari 58.888*70% untuk mendapatkan 28.778, dan level akan diperbarui ke VIP8. Hadiah bulan ini dapat diklaim hingga akhir bulan.',
  score3_explain_popup_tip19: '5. Platform berhak atas interpretasi akhir.',
  score3_explain_popup_tip20: 'Hadiah penawaran bulan ini {msg}',
  score3_explain_popup_tip21:
    'Level saat ini {msg}, setelah bulan depan tanggal 1 bisa mengambil {msg2} hadiah',
  score3_explain_popup_tip22:
    'Saat ini {msg}, kumpulkan lebih banyak poin keanggotaan untuk mendapatkan penawaran hadiah!',
  score3_explain_popup_tip23: 'Ambil hadiah',
  score3_explain_popup_tip24:
    'Setelah diambil, level akan berubah menjadi {msg}',
  score3_explain_popup_tip26:
    '4. Babak baru penyesuaian akan dilakukan pada hak keanggotaan pada 15 Mei, dan perhiasan baru seperti gelar, lencana, dan UUID akan segera hadir. Tunggu kabar selanjutnya!',
  claim_successful: 'Pengambilan berhasil',
  score3_explain_popup_tip25: 'Harap diperhatikan, level saat ini {msg}',
  gold_membership: 'Member Gold',
  'refund_application_in_progress':
    'Pengajuan pengembalian dana sedang diproses',
  already_refused_refund: 'Pengembalian dana ditolak',
  refund_application_has_been_rejected: 'Pengajuan pengembalian dana ditolak',
  pending_payment: 'Menunggu pembayaran',
  refund_completed: 'Pengembalian dana berhasil',
  boosting_coach_confirmed_completion:
    'Pelatih telah mengonfirmasi penyelesaian',
  normal: 'Biasa',
  gold: 'Emas',
  black_gold: 'Platinum',
  legendary: 'Legendaris',
  pending_evaluation: 'Menunggu ulasan',
  on_useSafari: 'Silakan buka tautan ini dengan browser ponsel Anda',
  on_callApp: 'Panggilan APP',
  order_allOrders: 'Semua Orderan',
  order_activeOrders: 'Orderan sedang berlangsung',
  order_historyOrders: 'Riwayat orderan',
  order_realCount: 'Pembayaran aktual',
  order_orderDetails: 'Detail orderan',
  order_created: 'Dibuat',
  order_acceptedOrder: 'Anda menerima orderan',
  order_orderCompleted: 'Orderan selesai',
  order_Confirmorder: 'Apakah konfirmasi menerima orderan?',
  order_Ordercanceled: 'Batalkan orderan',
  order_Rejectorder: 'Menolak orderan',
  order_Rejectcancellation: 'Apakah menolak orderan',
  order_OnceConfirmorder:
    'Anda tidak dapat membatalkan orderanan setelah Anda menerimanya. Konfirmasi orderan?',
  order_responseto: 'Anda tidak menerima dalam waktu 10 menit.',
  order_gotit: 'Mengerti',
  order_automaticallycanceled: 'orderan, pembatalan orderan',
  order_YesCancel: 'Konfirmasi pembatalan',
  order_YesCompleted: 'Konfirmasi Penyelesaian',
  order_Yes: 'Konfirmasi',
  order_cancelOrder: 'Pembatalan Orderan',
  order_thinkAgain: 'Pikirkan lagi',
  order_Orderconfirmed: 'Orderan Dikonfirmasi',
  order_rejectorder:
    'Jika Anda menolak, orderan Anda akan segera dibatalkan, apakah Anda konfimasi menolak?',
  order_Orderrejected: 'Orderan Ditolak',
  order_Successful: 'Sukses!',
  order_Successfully: 'Sukses!',
  order_noorders: 'Tidak ada orderan saat ini',
  order_Reject: 'menolak',
  order_Confirming: 'Menunggu orderan',
  order_inProgress: 'Dalam berlangsung',
  order_cancellationRequest: 'Dalam Pemrosesan aplikasi',
  order_Dispute: 'Dalam Pemrosesan aplikasi',
  order_Confirm: 'Konfirmasi',
  order_active: 'Orderan Aktif',
  order_history: 'Riwayat Pesanan',
  order_acceptedorder: 'Player menerima orderan',
  order_Writereview: 'menulis komentar',
  order_Tapstars: 'Klik bintang untuk mengomentari player ya',
  order_Surecancelorder: 'Apakah orderan dibatalkan?',
  order_Surecompleteorder: 'Apakah orderan sudah selesai?',
  order_reachedagreement:
    'Silakan berbicara dengan player sebelum mengajukan keluhan ya.',
  order_permenantlyclosed: 'Konfirmasi pembatalan orderan?',
  order_completeorder:
    'Anda tidak bisa mendapatkan pengembalian dana setelah menyelesaikan orderan',
  order_confirmacceptorder: 'Konfirmasi pembatalan orderan?',
  order_Order: 'Nomor Orderan',
  order_canceled: 'batal',
  order_Play: 'Bermain bersama',
  order_with: 'dengan',
  order_Quantity: 'Jumlah',
  order_Subtotal: 'Total harga',
  order_Total: 'Pembayaran aktual',
  order_purchaseSkill: 'Membeli skill',
  order_Note: 'Catatan',
  order_CompleteOrder: 'Orderan selesai',
  order_Orders: 'Orderan',
  order_myorder: 'Orderan Saya',
  order_Received: 'Orderan Teman Bermain',
  order_Placed: 'Orderan Saya',
  order_Acceptcancellation: 'Apakah pembatalan aplikasi diterima?',
  follow_FollowList: 'Ikuti',
  follow_Following: 'Dafter Ikuti',
  follow_Follower: 'Dafter Penggemar',
  follow_Follow: 'Penggemar',
  follow_Followers: 'Penggemar',
  follow_followyourself: 'Tidak dapat mengikuti diri Anda sendiri',
  follow_unfollow: 'Konfirmasi batal mengikuti',
  follow_nofollowers: 'Belum ada fans ya',
  follow_nofollowing:
    'Belum mengikuti pendamping, buka halaman pertama dan lihatlah',
  player_wirteReview: 'Tulis komentar',
  player_Review: 'Komentar pengguna',
  player_Reviews: 'Komentar pengguna',
  player_SeeMore: 'Peluas',
  player_Skills: 'Skill',
  player_localtime: 'Waktu setempat',
  player_Buy: 'Order',
  player_gamers: 'Pendamping',
  player_moreSkills: 'Lebih banyak item skill',
  player_findGamers: 'Jelajahi lebih banyak pendamping',
  player_noratings: 'Belum ada komentar',
  player_SeeAll: 'Lihat semua',
  player_Showmore: 'Tulis lebih banyak tentang diri Anda',
  player_suchempty: 'Kosong~',
  player_editprofile: 'Edit informasi pribadi',
  player_Followed: 'Sudah mengikuti',
  player_Unfollow: 'Batal mengikuti',
  player_Cancel: 'Batal',
  skill_Add: 'Tambahkan skill',
  skill_Skills: 'Manajemen skill',
  skill_finishSetting: 'Selesaikan pengaturan',
  skill_Verifying: 'Dalam ditinjau',
  skill_Level: 'Level',
  skill_Rating: 'Nilai',
  skill_ConnectionNumber: 'Jumlah pesanan yang diterima',
  skill_SelfIntroduction: 'Deskripsi',
  skill_chat: 'Obrolan',
  skill_Whoops: 'Ahhh!',
  skill_OK: 'OK',
  skill_Withdraw: 'Tarik',
  skill_Noconnection:
    'Sambungan Internet terputus! Silakan periksa koneksi Internet Anda.',
  skill_tryAgain: 'Coba lagi ya',
  skill_Price: 'Harga',
  skill_pricePer: 'Setiap 30 menit',
  skill_Earnings: 'Penghasilan',
  skill_hourserved: 'Durasi skill',
  skill_Transactions: 'Rincian transaksi',
  skill_orderTaking: 'Skill terbuka',
  skill_onlyWithDraw:
    'Penghasilan Anda hanya dapat ditarik setelah izin 30 hari.',
  record_contactus: 'Hubungi kami',
  record_ResolutionCenter: 'Pusat layanan pelanggan',
  record_Pendingclearance: 'Menunggu perhitungan',
  record_sentemail: 'Pastikan Anda sudah mengirim email',
  record_Clearance: 'Menghitung',
  record_Hi: 'Halo',
  record_Sent: 'Saya sudah mengirimkannya melalui email',
  record_example: 'Contoh',
  record_morehelp:
    'Jika Anda memerlukan bantuan lebih lanjut, silakan hubungi kami di alamat email resmi kami. Email kami adalah:',
  record_Game: 'Item skill',
  record_SendEmail: 'Kirim email',
  record_rejectedcancellation:
    'Karena Anda menolak permintaan pembatalan, silakan kirimkan Email kepada kami, tuliskan alasannya dan unggah file melalui lampiran untuk mendukung pandangan Anda. Anda akan mendapatkan jawaban dari kami dalam waktu 72 jam. Alamat Email kami adalah',
  record_applyingcancel:
    'Karena Anda mengajukan permohonan untuk membatalkan pesanan, silakan kirimkan Email kepada kami, tuliskan alasannya dan unggah file dengan lampiran untuk mendukung pandangan Anda. Anda akan mendapatkan balasan dari kami dalam waktu 72 jam. Alamat Email kami adalah',
  record_OrderID: 'ID Orderan',
  record_Copy: 'Salin',
  record_Totalprice: 'Total harga',
  record_name: 'Nama',
  record_Withdrawn: 'Tarik',
  record_Availabletowithdraw: 'Penghasilan yang dapat ditarik',
  record_amountofevery: 'Minimal NT$3000 dan maksimal NT$10000 per ditarik',
  record_onlywithdrawonce: '3-5 hari kerja setelah penarikan',
  record_Yourearningscan: 'Hanya setelah mencapai NT$3000 Anda bisa ditarik',
  record_reviewthecase: 'Pastikan email telah terkirim.',
  record_stepinthease:
    'Jika Anda telah mengirim email, nicee akan menanganinya',
  record_canwithdraw:
    'Setiap transaksi akan melalui proses kliring 7 hari sebelum Anda dapat menarik dana',
  recharge_details: 'Rincian',
  select_amount: 'Silakan pilih nominal',
  card_number: 'Nomor Rekening',
  security_code: 'Kode keamanan',
  remember_card_confirm:
    'Saya setuju untuk mengingat informasi kartu untuk pembayaran berikutnya.',
  tax: 'Biaya pajak',
  handling_fee_three:
    'Biaya penanganan（Dikumpulkan oleh arus kas pihak ketiga）',
  no_expired_coupons: 'Tidak ada Kupon Tidak Valid',
  full_discount_offer2: 'Beli{msg} gratis{msg2}',
  recharge_confirm: 'Pergi Top Up',
  nicee_coins: 'Koin nicee',
  in_payment: 'Sedang membayar',
  send_red_bag_orders: 'Berikan paket merah untuk orderan cepat',
  red_bag_features: 'Fitur Baru Paket Merah',
  game_coaches_are_claiming_orders: '{msg} teman sedang mengambil orderan',
  amount_available_gift: 'Jumlah dapat hadiahkan',
  gift_amount_info:
    'Hadiahkan penghasilan Anda kepada teman-teman Anda dan penghasilan tersebut akan ditukar 1:1 dengan nicee coin ke dalam akun dompet teman, secara instan.',
  gift_amount_info2:
    'Pesta Summer！Jika jumlah hadiah pertama melebihi $1000, pemberi hadiah akan menerima bonus 1000 permata',
  confirm_gift: 'Konfirmasi hadiah',
  pricing: 'Harga',
  price_setting: 'Pengaturan harga',
  'add_more-pricing': 'Tambahkan lebih banyak harga',
  unit: 'Unit',
  preferential: 'Diskon',
  full_discount_offer: 'Diskon Tambahan',
  first_order_discount: 'Diskon Pertama',
  not_set: 'Tidak dikonfigurasi',
  grades_and_introductions: 'Level dan presentasi',
  're-edit': 'Edit ulang',
  boosters_have_replied_please_select_your_preferred_booster:
    'Ada{msg} teman menanggapi Anda, silakan pilih teman yang Anda sukai',
  boosters_have_taken_orders_waiting_for_selection:
    '{msg} teman mengambil orderan，menunggu pemilihan',
  boosters_are_waiting_for_your_response_whom_would_you_like_to_choose:
    '{msg} teman menunggu respon Anda, mana yang akan Anda pilih?',
  withdraw_tip:
    'Untuk memastikan keamanan akun Anda, Anda perlu mengikat dan mengautentikasi akun saat melakukan penarikan reguler. Selama proses otentikasi, Anda tidak dapat mengedit informasi atau menarik jumlah uang.',
  go_to_certification: 'Verifikasi',
  manual_withdrawals: 'Penarikan manual',
  withdraw_able_amount: 'Jumlah yang dapat ditarik:',
  withdraw_limit: '(Batas di minggu ini: {msg})',
  withdraw_amount: 'Jumlah penarikan',
  withdraw_account: 'Penarikan ke akun',
  withdrawal_verification:
    'Belum terverifikasi/Informasi yang diisi salah? Pergi untuk mengubah>>',
  user_name: 'Nama pengguna',
  withdraw_bankname: 'Nama bank penarikan',
  branch_code: 'Kode bank',
  weChat_nickname: 'Nama WeChat',
  weChat_account: 'Akun WeChat',
  read_and_agreed: 'Saya telah membaca dan menyetujui',
  withdraw_method: 'Aturan penarikan',
  personal_data: 'Informasi pribadi',
  real_name: 'Nama asli',
  withdraw_account_validator: 'Nama pada KTP tidak boleh kosong',
  ID_number: 'Nomor Kartu Identitas',
  withdraw_account_validator2: 'Silakan isi NIK Anda dengan benar',
  permanent_address: 'Alamat KTP',
  withdraw_account_validator3: 'Isi alamat KTP Anda dengan benar',
  front_photo_of_ID_card: 'Foto bagian depan KTP',
  back_photo_of_ID_card: 'Foto bagian belakang KTP',
  withdraw_account_validator4: 'Pastikan foto terlihat jelas',
  withdraw_account_validator5: 'Format yang didukung: jpg, jpeg, png',
  withdraw_account_validator6: 'Ukuran file tidak boleh melebihi 3M',
  bank_details: 'Informasi bank',
  bank_name: 'Nama bank',
  withdraw_account_validator7: 'Isi nama WeChat Anda dengan benar',
  wechat_account: 'Akun Wechat',
  withdraw_account_validator8: 'Isi akun WeChat Anda dengan benar',
  wechat_screen: 'Screenshot halaman akun WeChat',
  upload_wechat_screen_tip: 'Silakan unggah gambar sampul akun WeChat Anda',
  ranking_rules: 'Peraturan Rangking',
  reward: 'Reward',
  first_unit_price: 'harga pertama',
  '1_coin_purchase_restriction': '1 Batas Koin',
  after_coupon_price: 'harga pasca-kupon',
  order_quantity: 'Jumlah pesanan yang diterima',
  user_rating: 'peringkat pengguna',
  evaluate: 'evaluasi',
  no_rating: 'Tidak ada peringkat',
  review_count: '{msg}Reviews',
  chat_disable_tip:
    'Harap mengikat nomor ponsel untuk mengaktifkan fungsi obrolan',
  chat_disable_tip2: 'Mengaktifkan lebih banyak fitur setelah top up pertama',
  bind_phone_confirm: 'mengikat nomor ponsel',
  rating_detail:
    'Pendamping ini memiliki peringkat keseluruhan yang tinggi dan kinerja keseluruhan yang sangat baik, jadi pilihlah dia ya~',
  rating_info:
    'Peringkat keseluruhan adalah penilaian kualitas kinerja pendamping secara keseluruhan dan mewakili sikap dan kualitas pendamping.',
  ask_player: 'Tanyakan pada pendamping',
  last_three_codes: 'tiga kode terakhir',
  give_diamond: 'Beri{msg}permata',
  ability_attributes: 'Jenis skill',
  skill_profiles: 'Profil skill',
  'average_pricing_skill:': 'Harga rata-rata untuk skill ini:',
  remarks_sounds_good: 'Catatan（optional）: "Suara bagus", dll.',
  red_bag_order_title:
    'Gunakan "amplop merah" untuk lebih banyak orderan cepat！',
  red_bag_order_info:
    'Mengatur jumlah total.Setelah orderan dikirim, 15 teman pertama yang mengambil pesanan akan menerima amplop merah secara "acak". Jika ada kurang dari lima belas orang, jumlah yang tersisa akan dikembalikan di akhir orderan.(Saat ini tidak ada komisi untuk fitur ini)',
  get_more_bosses: 'Lepaskan untuk memanggil lebih banyak bos yang aktif...',
  pull_up_refresh: 'Tarik ke atas dan segarkan',
  vocality_updating: 'Memperbarui',
  potential: 'potensi',
  recently_placed_order: 'Orderan terbaru',
  new_user_not_order: 'Pengguna baru dan Belum order',
  say_hi: 'Sapa',
  say_hello_success: 'Sapaan sukses',
  received_friend_ID: 'ID Teman yang diberi',
  recipient_nickname: 'Nama teman yang diberi',
  user_not_exist: 'Pengguna tidak ada',
  unable_gift_oneself: 'Tidak bisa memberikannya kepada diri Anda sendiri.',
  please_enter_valid_friend_ID: 'Silakan masukkan ID teman yang valid',
  fill_in_gift_amount: 'Silakan isi jumlah hadiah',
  more_than_price: 'Jumlah hadiah melebihi jumlah yang dapat dihadiahkan',
  gift_success: 'Hadiah sukses',
  gift_amount_user: 'Hadiah {msg} kepada{msg2}',
  withdraw_tip2:
    'Anda dapat menarik maksimum NT$19.999 per minggu dan persyaratan minimum untuk satu kali penarikan adalah NT$1.000.',
  withdraw_tip3:
    'Batas penarikan mingguan diperbarui setiap hari Senin pukul 8:00.',
  withdraw_tip4:
    'Mohon bersabar karena diperlukan waktu 3-7 hari kerja untuk proses penarikan dan pengalokasian dana.',
  withdraw_tip5:
    'Jika diminta oleh IRS, nicee berkewajiban untuk bekerja sama dengan IRS untuk membantu memberikan informasi yang relevan.',
  withdraw_tip6:
    '1. Sesuai dengan ketentuan hukum terkait di Taiwan, pengguna yang mengajukan penarikan diminta untuk menyediakan dokumen yang diperlukan agar pihak nicee dapat membantu dalam pengisian formulir penghasilan. Saat pertama kali melakukan proses penarikan, Anda akan diminta mengunggah foto identitas diri (depan dan belakang) Anda. Jika ada masalah dengan informasi yang Anda berikan, tim nicee akan menghubungi Anda untuk menyelesaikan masalah terkait.',
  withdraw_tip7:
    '2. Saya menjamin bahwa semua informasi yang saya berikan adalah milik saya sendiri. Jika terjadi masalah apapun, saya bersedia bertanggung jawab secara hukum.',
  withdraw_tip8:
    '3. Setelah pengajuan penarikan, informasi pribadi dan rekening bank akan secara otomatis terhubung. Jika Anda perlu mengubahnya, silakan hubungi layanan pelanggan.',
  withdraw_tip9:
    '4.Platform akan memeriksa format dari semua dokumen grafis yang diajukan oleh pengguna. Platform tidak bertanggung jawab atas kesalahan penulisan rekening atau masalah lain yang disebabkan oleh kesalahan pribadi pengguna.',
  committing: 'Dikirimkan...',
  account_under_review: 'Akun sedang berlangsung',
  withdraw_diabled:
    'Akun ini sedang ditinjau dan tidak dapat dimodifikasi untuk saat ini.',
  not_logged_in: 'tidak masuk',
  exceeded_withdrawal_limit: 'Melebihi jumlah yang dapat ditarik',
  withdrawal_account: 'Akun penarikan',
  weChat_withdrawal: 'Menarikan di Wechat',
  withdraw_diabled2: 'Akun Anda belum diautentikasi, silakan autentikasi ulang',
  withdraw_validator1: 'Penarikan tunggal tidak boleh melebihi {msg}',
  withdraw_validator2: 'Masukkan bilangan bulat',
  withdraw_validator3: 'Jumlah setiap penarikan tidak boleh kurang dari {msg}',
  withdraw_validator4: 'Jumlah penarikan tidak boleh 0',
  withdraw_diabled3:
    'Akun ini sedang ditinjau dan tidak dapat diajukan untuk saat ini.',
  branch_name: 'Nama bank',
  account_number: 'Nomor Rekening',
  confirm_submission: 'Konfirmasi kirim',
  withdraw_account_validator9:
    'Nama kartu identitas harus sama dengan nama rekening pada data bank',
  withdraw_account_validator10: 'Masukkan 2-10 karakter',
  withdraw_account_validator11: 'Masukkan 10-14 digit nomor ID yang benar',
  withdraw_account_validator12: 'Foto depan tidak boleh kosong',
  withdraw_account_validator13: 'Foto terbalik tidak boleh kosong',
  click_select_bank: 'Klik untuk memilih bank',
  withdraw_account_validator14:
    'Harap isi nama pengguna Paypal Anda dengan benar.',
  withdraw_account_validator15:
    'Harap isi nama bank Anda dengan benar (maksimum 20 karakter)',
  withdraw_account_validator16: 'Silakan masukkan 1-20 karakter',
  withdraw_account_validator17: 'Informasi WeChat tidak boleh kosong',
  withdraw_account_validator18:
    'Harap isi nama bank Anda dengan benar (maksimum 20 karakter)',
  withdraw_account_validator19: 'Harap isi Email Paypal Anda dengan benar.',
  withdraw_account_validator20:
    'Harap isi nomor rekening Anda dengan benar (hanya angka, antara 10-14 digit)',
  withdraw_account_validator21: 'Email yang tidak sesuai dengan aturan',
  withdraw_account_validator22: 'Silakan masukkan 10 ~ 14 digit',
  withdraw_account_validator23:
    'Halaman informasi buku tabungan tidak boleh kosong',
  upload_bank_screen_tip:
    'Silakan unggah halaman buku tabungan dengan nomor rekening bank',
  bank_screen:
    'Halaman informasi buku tabungan (*Halaman dengan nomor rekening bank)',
  applying_to_become_playmate: 'Ajukan untuk menjadi Pendamping',
  registered_playmate_info1: 'Pendamping nicee mengundang Anda',
  registered_playmate_info2: 'menjadi Pendamping kami',
  registered_playmate_info3: 'Kami menunggu Anda seperti ini:',
  registered_playmate_info4:
    'Lucu, suka mengobrol; menyukai permainan dan berteman.',
  registered_playmate_info5:
    'Entah Anda ingin tahu atau profesional, Anda ingin menjadi Pendamping yang baik.',
  registered_playmate_info6:
    'Jika itu adalah Anda, klik untuk mendaftar, mulailah perjalanan Anda sebagai pendamping!',
  registered_playmate_info7: 'Saya telah membaca dan menyetujui',
  registered_playmate_info8: '《Pedoman perilaku mitra nicee》',
  registered_playmate_info9: '《Ketentuan Layanan dan Kebijakan Privasi》',
  registered_playmate_info10:
    'Saya setuju dengan persyaratan di atas, dan ajukan sekarang',
  registered_playmate_step_info1:
    'Tiga langkah mudah, Nicee membantu Anda bermain dengan gembira! Dapatkan uang dengan mudah!',
  registered_playmate_step_info2: 'Tes pengantar',
  registered_playmate_step_info3:
    'Ini akan membantu Anda mengenal Nicee dengan cepat, jadi bacalah dengan saksama dan selesaikan kuisnya!',
  registered_playmate_step_info4:
    'Selamat atas kelulusan Anda dalam tes ini, isi informasi sekarang!',
  registered_playmate_step_info5: 'Tes ulang',
  registered_playmate_step_info6: 'Pergi ke tes',
  registered_playmate_step_info7: 'Isi informasi',
  registered_playmate_step_info8:
    'Tunjukkan diri Anda yang paling unik! Konten yang menarik dapat menarik pengguna dan mendapatkan eksposur~',
  registered_playmate_step_info9: 'Pergi ke isi',
  registered_playmate_step_info10: 'Tinjauan kualifikasi',
  registered_playmate_step_info11:
    'Audit akan selesai dalam 1 hari kerja, harap isi informasi di langkah 2 dengan hati-hati ~ Semoga sukses untuk audit Anda! ~',
  registered_playmate_question_info1: 'Pilihan salah, silakan coba lagi.',
  registered_playmate_question_info2: 'Lihat Tips',
  registered_playmate_question_info3: 'Berikutnya',
  registered_playmate_question_info4: 'Kirim Tes',
  registered_playmate_question_info5:
    'Jika Anda berhenti di tengah permainan, jawaban Anda sebelumnya akan terhapus, jadi harap pertimbangkan baik-baik.',
  registered_playmate_question_info6: 'Lanjutkan',
  registered_playmate_question_info7: 'Pilih keluar',
  registered_playmate_question_info8:
    'Harap selesaikan pertanyaan sebelum melanjutkan',
  registered_playmate_question1: '1: Siapakah pendampingnya? (Pilihan ganda)',
  registered_playmate_question2:
    'Seorang master game yang dapat menghadirkan sensasi bermain game kepada orang-orang.',
  registered_playmate_question3:
    'Suara yang bagus dan humor, bersedia menghabiskan waktu dengan orang-orang',
  registered_playmate_question4:
    'Suara nyanyian yang bagus, dapat memberikan kenikmatan pendengaran bagi orang lain',
  registered_playmate_question5:
    'Tarot, horoskop, emosi, pengingat, gambar... Saya yakin Anda akan menemukan kegunaan dari semua bakat Anda.',
  registered_playmate_question6:
    '2: Bagaimana cara mendapatkan uang? (Pilihan ganda)',
  registered_playmate_question7: 'Membuat profil keterampilan yang menarik',
  registered_playmate_question8: 'Secara aktif mengambil pesanan di lobi',
  registered_playmate_question9:
    'Promosikan diri Anda dengan konten yang menarik di Plaza',
  registered_playmate_question10:
    'Tunjukkan diri Anda dalam permainan atau media sosial. Gunakan nama panggilan Nicee agar orang lain dapat menemukan Anda!',
  registered_playmate_question11:
    'Mempertahankan pelanggan yang sudah ada, memberikan pelayanan yang proaktif, dan menyediakan layanan yang berkelanjutan',
  registered_playmate_question12: 'Optimisme, Profesionalisme',
  registered_playmate_question13:
    '3: Bagaimana menarik pendapatan (Pilihan ganda)',
  registered_playmate_question14: 'Nama asli',
  registered_playmate_question15: 'Menunggu penyelesaian sistem',
  registered_playmate_question16: 'Mengikat rekening bank',
  registered_playmate_question17:
    'Mendesak layanan pelanggan untuk mempercepat menarik',
  registered_playmate_question18:
    'Komunikasi negatif dengan layanan pelanggan jika terjadi keraguan pembayaran',
  registered_playmate_question19:
    '4: Bagaimana cara melindungi diri Anda? (Pilihan ganda)',
  registered_playmate_question20:
    'Untuk pesanan dalam jumlah besar, pastikan konten transaksi dan catatan obrolan disimpan',
  registered_playmate_question21:
    'Jika Anda menemukan pengguna ilegal, laporkan mereka secara aktif untuk menjaga keamanan platform dan pengawalan lainnya',
  registered_playmate_question22:
    'Jika terjadi perselisihan atau kontroversi, berinisiatiflah untuk menghubungi layanan pelanggan untuk mencari solusi',
  registered_playmate_question23:
    'Tidak menghormati privasi pengguna. Posting tangkapan layar obrolan pelanggan langsung ke plaza',
  registered_playmate_question24:
    'Menyerang orang di dunia nyata dengan mencari di Internet',
  registered_playmate_question25:
    '5: Perilaku apa saja yang dilarang dan dihukum oleh Platform? (Pilihan ganda)',
  registered_playmate_question26:
    'Memposting konten yang tidak terkait dengan game atau layanan',
  registered_playmate_question27: 'Penipuan',
  registered_playmate_question28: 'Serangan fisik terhadap orang lain',
  registered_playmate_question29:
    'Bekerja sama dengan kelompok keuangan ilegal dalam pencucian uang',
  registered_playmate_question30:
    '6: Sebagai pendatang baru, bagaimana memulai langkah pertama ? (Pilihan ganda)',
  registered_playmate_question31: 'Mengirim banyak foto selfie yang indah',
  registered_playmate_question32:
    'Posting banyak skor dan video permainan yang mengagumkan',
  registered_playmate_question33:
    'Masukkan halaman pribadi IG, Tiktok, Twitch, dan Youtube ke dalam pengantar agar mudah dipahami.',
  registered_playmate_question34: 'Mengambil orderan agresif',
  registered_playmate_tip1:
    'Nicee adalah platform perdagangan layanan virtual terbuka, di mana para pendamping dapat menggunakan imajinasi mereka untuk membuat barang virtual dan secara bebas menentukan harga layanan yang dapat mereka sediakan dalam batas-batas hukum.',
  registered_playmate_tip2:
    'Bagaimana Anda menampilkan diri Anda dalam presentasi keterampilan adalah kunci untuk mendapatkan pesanan pertama.',
  registered_playmate_tip3:
    'Hargailah semua pelanggan yang telah memesan dari Anda, mereka akan menjadi sumber pendapatan yang paling objektif di masa depan',
  registered_playmate_tip4:
    'Membagikan diri Anda di game dan media sosial dapat membuat Anda mendapatkan banyak pelanggan potensial yang tepat',
  registered_playmate_tip5:
    'Pola pikir yang positif, optimis, dan menular selalu menjadi aset Anda yang paling berharga',
  registered_playmate_tip6:
    'Setelah pengguna mengonfirmasi penyelesaian pesanan, platform akan melakukan penilaian risiko terhadap sumber dana, yang kemudian perlu dihubungkan dengan bank dan pihak streaming emas. Hanya ketika dana dikonfirmasi aman, dana tersebut dapat dikreditkan ke akun untuk penyelesaian. Berdasarkan pengalaman sebelumnya, sebagian besar penyelesaian akan selesai dalam 1-2 hari, namun, jika sumber dana melaporkan alarm selama penilaian risiko, penyelesaian akan tertunda. Pada saat ini, pengguna perlu secara aktif berkomunikasi dengan layanan pelanggan dan menyediakan bahan pemesanan bonafid yang sesuai sampai risiko dihapus. Ketika penyelesaian dana selesai, pendamping dapat menarik dana, harap pastikan bahwa informasi nama asli Anda sama dengan rekening bank Anda untuk memastikan bahwa pembayaran resmi dilakukan secara normal.',
  registered_playmate_tip7:
    'Prosedurnya sudah terstandardisasi dan mendesak layanan pelanggan tidak akan mempercepat narik.',
  registered_playmate_tip8:
    'Keamanan selalu diutamakan. Platform terbuka akan menghadapi berbagai kebutuhan pengguna, silakan hubungi layanan pelanggan pada saat pertama kali ketika ada ancaman, atau kerusakan pada hak dan kepentingan mereka sendiri. Berikan catatan yang benar, obyektif, dan lengkap tentang catatan komunikasi dan transaksi yang relevan untuk memfasilitasi pemrosesan resmi. Jika perlu, petugas akan bekerja sama dengan pengguna dan polisi untuk menyelaraskan situasi, tetapi jangan bertindak berdasarkan dorongan hati atau secara membabi buta melapor ke polisi tanpa bukti atau fakta kejahatan yang jelas.',
  registered_playmate_tip9:
    'Berpartisipasi dalam penipuan dan pencucian uang adalah pelanggaran serius dan platform akan melaporkan semua kasus. Bagi mereka yang terlibat langsung, platform akan menyerahkan kepada pihak berwajib dengan informasi nama asli dan perilaku mereka; mereka yang tidak terlibat langsung tetapi mengetahui hal tersebut akan diblokir, dihentikan dan ditarik sesuai dengan perjanjian pengguna platform untuk kepentingan platform atau kerugian kepentingan orang lain.',
  registered_playmate_tip10:
    'Menciptakan daya tarik adalah langkah pertama yang penting bagi pendatang baru untuk memulai. Percayalah bahwa Anda selalu unik dan yang terbaik!',
  registered_playmate_data_info1: 'Isi data pribadi',
  registered_playmate_data_info2: 'Avatar',
  registered_playmate_data_info3: 'Pastikan avatar Anda jelas dan otentik',
  registered_playmate_data_info4: 'Silakan unggah avatar Anda',
  registered_playmate_data_info5: 'Nama',
  registered_playmate_data_info6: 'Silakan masukkan nama',
  registered_playmate_data_info7: 'Nama harus antara 3-30 karakter',
  registered_playmate_data_info8: 'Usia',
  registered_playmate_data_info9: 'Silakan masukkan usia',
  registered_playmate_data_info10: 'Silakan atur usia',
  registered_playmate_data_info11:
    'Melarang pengguna yang berusia di bawah 18 tahun untuk melamar menjadi pendamping',
  registered_playmate_data_info12: 'Pilih jenis kelamin',
  registered_playmate_data_info13: 'Mengikat Nomor Ponsel',
  registered_playmate_data_info14:
    'Digunakan untuk login dan manajemen akun pribadi, tidak ditampilkan ke publik.',
  registered_playmate_data_info15: 'Nomor ponsel terikat',
  registered_playmate_data_info17: 'Silakan mengikat Nomor Ponsel',
  registered_playmate_data_info18: 'Lanjut',
  registered_playmate_data_info19: 'Silakan unggah avatar Anda',
  registered_playmate_data_info20: 'Nama harus antara 3-30 karakter',
  registered_playmate_data_info21: 'Pilih jenis kelamin',
  registered_playmate_data_info22: 'Silakan mengikat Nomor Ponsel',
  registered_playmate_data_info23: 'Silakan atur usia',
  registered_playmate_data_info24: 'Aktifkan skill pertama Anda: Obrolan Suara',
  registered_playmate_data_info25:
    'Skill ini diperlukan secara default. Anda bisa memilih untuk membuka order atau tidak dan menyesuaikan harga setelah data ditinjau.',
  registered_playmate_data_info26: 'Jenis suara saya',
  registered_playmate_data_info27: 'Pengenalan skill',
  registered_playmate_data_info28:
    'Jelaskan skill Anda dan apa yang diberikan oleh skill tersebut.',
  registered_playmate_data_info29: 'Konten tidak kurang dari 30 kata',
  registered_playmate_data_info30: 'Merekam',
  registered_playmate_data_info31: '150 koin/ 30 menit',
  registered_playmate_data_info32:
    'Luar biasa! Kami sedang meninjau profil Anda dan akan menghubungi Anda dalam waktu 24 jam ya~',
  registered_playmate_data_info33: 'Mengerti',
  registered_playmate_data_info34:
    'Silakan pilih satu skill yang Anda mau ajukan',
  registered_playmate_data_info35: 'Games',
  registered_playmate_data_info36: 'Hiburan online',
  registered_playmate_data_info37: 'Pesan teman',
  registered_playmate_data_info38: 'Lain',
  registered_playmate_data_info39: 'Maksimal 3 skill dapat diterapkan',
  registered_playmate_data_info40: 'Silakan edit file {msg} skill Anda',
  registered_playmate_data_info41:
    'Pilih kategori skill yang paling sesuai dengan Anda',
  registered_playmate_data_info42: 'Pilih level game Anda',
  registered_playmate_data_info43: 'Judul skill',
  registered_playmate_data_info44:
    'Silakan tentukan judul untuk skill Anda, konten yang tidak sah tidak akan disetujui (judul tidak boleh lebih dari 6 karakter).',
  registered_playmate_data_info45: 'Judul skill Anda',
  registered_playmate_data_info46: 'Unggah gambar',
  registered_playmate_data_info47:
    'Harap unggah tangkapan layar yang menunjukkan keahlian Anda yang relevan. Pastikan tangkapan layar tersebut jelas dan tidak ada pornografi, kekerasan, atau konten ilegal lainnya di dalam foto tersebut.',
  registered_playmate_data_info48: '(Opsional)',
  registered_playmate_data_info49: 'Contoh',
  registered_playmate_data_info50:
    'Keterampilan non-game dapat membantu meningkatkan daya tarik dengan menampilkan "Kartu Identifikasi Suara". Jika Anda perlu membuatnya, hubungi',
  registered_playmate_data_info51: 'teknisi suara platform',
  registered_playmate_data_info52: 'untuk mendapatkan bantuan.',
  registered_playmate_data_info53:
    'Menampilkan informasi untuk menyembunyikan ID, silakan klik',
  registered_playmate_data_info54: 'Sembunyikan',
  registered_playmate_data_info55: 'Saya ingin menyembunyikan ID saya',
  registered_playmate_data_info56:
    'Tampilkan Pesan\nTangkapan layar segmen dengan ID game hanya akan digunakan untuk tinjauan internal, dan gambar di bawah ini akan ditampilkan setelah skill tersebut dilewati.',
  registered_playmate_data_info57: 'Otentikasi Game (opsional)',
  registered_playmate_data_info58:
    'ID Game hanya untuk audit platform, setelah lulus audit, Anda akan disertifikasi oleh platform berdasarkan tingkat keahlian Anda ya!',
  registered_playmate_data_info59:
    'Silakan masukkan ID game yang Anda gunakan untuk menerima pesanan',
  registered_playmate_data_info60:
    'Pilihlah mode yang paling mahir dalam karier gaming Anda',
  registered_playmate_data_info61: 'Perkenalan diri',
  registered_playmate_data_info62:
    'Pengenalan keterampilan yang sederhana dan menarik，lebih mudah lulus audit dan membuat pengguna menyukainya! (Masukkan setidaknya 20 karakter)',
  registered_playmate_data_info63: 'Streamer',
  registered_playmate_data_info64:
    'PS：Silakan lampirkan tautan untuk mengajukan khusus streamer',
  registered_playmate_data_info65:
    'Contoh：Halo, saya XX Skill utama adalah League of Legends Posisi adalah Dukungan karakter XXX, selamat datang untuk bermain bersama',
  registered_playmate_data_info66: 'Pilih Mode',
  registered_playmate_data_info67:
    'Data Anda telah ditinjau, silakan periksa pesan atau refresh halaman ini, kami berharap dapat menerima hasilnya dalam 1 hari kerja.',
  registered_playmate_data_info68: 'Tinjauan kualifikasi',
  registered_playmate_data_info69: 'Diskon Pertama',
  registered_playmate_data_info70: 'Diskon Pertama',
  registered_playmate_data_info71: 'Tambahkan Diskon Pertama',
  registered_playmate_data_info72:
    'Pengguna dapat menikmati harga pertama yang Anda tetapkan untuk pesanan pertama yang mereka tempatkan dengan Anda',
  registered_playmate_data_info73:
    'Diskon hanya berlaku untuk pengguna yang telah melakukan setidaknya satu kali order di platform dan tidak dapat digunakan bersamaan dengan diskon pendatang baru',
  registered_playmate_data_info74:
    'Setelah membuka diskon ini, jika ada laporan tentang layanan, setelah diverifikasi, kualifikasi ini akan dibatalkan, mohon perhatian khusus',
  registered_playmate_data_info75:
    'Mode ( unit adalah 7 menit, mode default ke coba 7 menit)',
  registered_playmate_data_info76:
    'Contoh: Unit dipilih sebagai game, atur input sebagai mode bonus, lalu atur harga sebagai mode bonus 100 koin/game (isinya tidak boleh lebih dari 8 karakter).',
  registered_playmate_data_info77: 'Unit adalah jam, mode tidak dapat dipilih',
  registered_playmate_data_info78:
    'Nama mode tidak sesuai dengan standar, telah diatur ulang',
  registered_playmate_data_info79: 'Pengaturan Unit',
  registered_playmate_data_info80:
    'Unit skill yang Anda tetapkan saat ini adalah: {msg}hari',
  registered_playmate_data_info81:
    'Silakan periksa apakah harganya akurat dan bernegosiasi dengan pengguna tentang durasi permainan,setiap perselisihan pesanan yang timbul akibat penetapan unit harga akan ditanggung oleh pendamping.',
  registered_playmate_data_info82: 'Mengulangi pengaturan mode satuan ukuran',
  edit_success: 'Sukses modifikasi',
  add_success: 'Tambahkan sukses',
  edit_failed: 'Gagal modifikasi',
  add_failed: 'Tambahkan gagal',
  registered_playmate_data_info83: 'coba 7 menit',
  registered_playmate_data_info84:
    'Kisaran harga Extreme Experience hanya 30-40 nicee koin, silakan atur ulang',
  price_range_minutes7: 'Harga harus antara 30-40',
  price_range_limit: 'Harga harus antara {priceLeft}-{priceRight}',
  price_range_invalid: 'Silakan masukkan harga yang valid',
  custom_price: 'Harga kustom',
  custom_price_placeholder: 'Masukkan harga',
  save_failed: 'Simpan gagal',
  skill_introduction_not_less_than_30_words:
    'Presentasi skill tidak kurang dari 20 kata',
  the_content_you_entered_contains_sensitive_words_please_reenter:
    'Konten yang telah Anda masukkan mengandung kata-kata sensitif, harap masukkan kembali.',
  application_submission_failed: 'Gagal mengirimkan ajuan',
  you_applied_to_become_a_game_buddy: 'Anda ajukan untuk menjadi pendamping',
  delete_first_order_discount: 'Apakah diskon pesanan pertama akan dihapus?',
  repurchase_order: 'Pesanan pembelian kembali',
  order_refund: 'Pengembalian dana pesanan',
  apply_for_refund: 'Mengajukan pengembalian dana',
  refund_details: 'Rincian pengembalian dana',
  write_review: 'Tulis review',
  view_review: 'Lihat review',
  accept_order_immediately: 'Pesan sekarang',
  place_another_order: 'Satu pesanan lagi',
  reason_for_declining_refund: 'Alasan penolakan pengembalian dana',
  please_enter_reason_for_declining_refund:
    'Masukkan alasan penolakan pengembalian dana',
  refund_application_details: 'Rincian mengajukan pengembalian dana',
  initiate_refund_application: 'Mulai mengajukan pengembalian dana',
  reason_for_appeal: 'Alasan untuk pengaduan',
  waiting_for_game_buddy_to_process_your_order_cancellation_request:
    'Menunggu permintaan pembatalan Anda diproses oleh pendamping',
  waiting_for_the_other_party_to_process_your_order_cancellation_request:
    'Menunggu permintaan pembatalan pihak lain diproses oleh Anda',
  rate_game_buddy: 'Evaluasi pendamping',
  star_rating_cannot_be_lower_than_the_original_rating_and_each_person_has_only_one_opportunity_to_modify_the_rating:
    'Catatan: Jumlah bintang dalam peringkat tidak boleh lebih rendah dari peringkat awal, dan setiap orang hanya memiliki satu kesempatan untuk mengubah peringkat',
  you_can_modify_the_rating_within_48_hours_after_the_initial_rating_the_star_rating_cannot_be_lower_than_the_original_rating_and_each_rating_can_only_be_modified_once:
    'Catatan: Anda dapat mengubah peringkat Anda dalam waktu 48 jam setelah menyelesaikan peringkat pertama Anda, jumlah bintang tidak boleh lebih rendah dari peringkat awal, dan setiap peringkat hanya dapat diubah satu kali ya~',
  tap_to_rate: 'Klik untuk menilai',
  please_enter_detailed_review_to_increase_exposure_for_him:
    'Silakan masukkan ulasan terperinci untuk membantunya mendapatkan lebih banyak eksposur~',
  please_enter_detailed_review_to_help_the_game_buddy_improve:
    'Silakan masukkan ulasan terperinci untuk membantu pendamping ini menjadi lebih baik~',
  add_tags: 'Menambahkan tag (hingga 3)',
  anonymous_rating: 'Ulasan Anonim',
  rated_you: 'Menilai Anda',
  you_rated_the_game_buddy: 'Anda menilai pendamping',
  modify_rating: 'Ubah penilaian',
  you_rated: 'Anda menilai',
  dislike: 'Tidak suka',
  '1_star_very_unsatisfied': '1 poin, sangat tidak puas',
  '2_stars_not_satisfied': '2 poin. tidak puas',
  '3_stars_average': '3 poin, rata-rata',
  '4_stars_pretty_good': '4 poin, bagus',
  '5_stars_excellent': '5 poin, sangat bagus',
  confirm_taking_this_order: 'Mengonfirmasi menerima pesanan?',
  'providing_high-quality_skills_and_receiving_detailed_five-star_reviews_can_help_you_get_more_exposure_and_orders!':
    'Memberikan skill berkualitas tinggi dan mendapatkan ulasan bintang 5 dengan deskripsi mendetail dapat membantu Anda mendapatkan lebih banyak eksposur dan pesanan!',
  confirm_accepting_order: 'Mengonfirmasi menerima pesanan',
  confirm_initiating_refund_request:
    'Mengonfirmasi dimulainya permintaan pengembalian dana?',
  after_initiating_a_refund_request_you_need_to_fill_in_the_reason_for_refund_only_after_the_game_buddy_agrees_can_the_order_be_cancelled_if_there_is_a_disagreement_you_can_contact_customer_service:
    'Anda harus mengisi alasan pengembalian dana setelah Anda memulai aplikasi pengembalian dana, dan hanya setelah pendamping setuju untuk membatalkan pesanan, jika ada ketidaksepakatan, Anda dapat menghubungi layanan pelanggan.',
  confirm_initiating: 'Mulai konfirmasi',
  confirm_rejecting_refund: 'Konfirmasi penolakan pengembalian dana?',
  after_confirming_rejecting_the_refund_the_platform_will_intervene_and_arbitrate_as_needed_the_arbitration_result_will_be_settled_within_seven_days_as_cancellation_or_completion:
    'Setelah menentukan penolakan pengembalian dana, Platform akan melakukan intervensi dalam arbitrase yang diperlukan, dan order akan dibatalkan atau diselesaikan dalam waktu tujuh hari tergantung pada hasil arbitrase.',
  reject_refund: 'Penolakan pengembalian dana',
  continue_applying_for_refund: 'Lanjutkan untuk meminta pengembalian dana',
  you_only_have_one_opportunity_to_modify_the_rating_confirm_submission:
    'Hanya satu kesempatan untuk mengubah penilaian Anda, konfirmasi kirim?',
  modify_rating_success: 'Sukses mengubah evaluasi',
  rating_success: 'Sukses evaluasi',
  please_fill_in_review_content: 'Silakan isi konten ulasan',
  the_content_you_entered_may_contain_sensitive_terms_please_reenter:
    'Konten yang telah Anda masukkan mungkin mengandung kata-kata sensitif, harap masukkan kembali',
  hours: 'Jam',
  minutes: 'Menit',
  seconds: 'Detik',
  confirm_canceling_order: 'Mengkonfirmasi pembatalan orderan ini?',
  occupancy_amount_is: 'Jumlah pelindung adalah {msg}',
  the_currently_set_initial_guardian_amount_is:
    'Saat ini amount awal pelindung',
  guardian_privileges: 'Hak istimewa pelindung',
  first_screen_guardian_position: 'Posisi pelindung layar pertama',
  comment_section_nickname_highlight: 'Nama panggilan yang disorot di komentar',
  original_price: 'Harga asli:',
  you_still_need: 'Anda masih hilang',
  set_initial_guardian_amount: 'Atur jumlah awal pelindung',
  guard_tip1:
    '1. Di sini Anda dapat mengatur jumlah uang awal yang diperlukan untuk menempati posisi pelindung dan jumlah uang yang diperlukan untuk memperbarui posisi pelindung untuk pengguna yang sama',
  guard_tip2:
    '2. Pengaturan ini langsung berlaku ketika tidak ada orang di posisi tersebut, dan ketika ada orang di posisi tersebut, maka akan digunakan sebagai jumlah pembaruannya',
  guard_tip3:
    '3. Perlindungan timbal balik dicapai ketika Anda menjadi pelindung pihak lain, dan bingkai bingkai profil akan ditingkatkan',
  guard_tip4: '4. Pengaturan dapat dimodifikasi setiap 30 hari sekali',
  guard_tip5:
    '1. Di sini Anda dapat mengatur jumlah uang yang diperlukan untuk menempati atau memperbarui posisi pelindung',
  guardian_gold_setting: 'Atur jumlah pelindung',
  guard_tip6:
    '2. Jika posisi pelindung kosong, pendudukan akan langsung berlaku; jika sudah ada pelindung, maka akan menjadi nominal perpanjangan pelindung sebelumnya',
  guard_tip7:
    '3. Jika saling menjadi pelindung, perlindungan bersama akan tercapai dan bingkai avatar eksklusif akan ditingkatkan',
  guard_tip8: '4. Pengaturan dapat diubah setiap 30 hari sekali',
  extend_guardian_period: 'Perpanjangan waktu pelindung',
  occupy_guardian_position: 'Menempati posisi pelindung',
  cannot_modify_within_30_days_after_last_setting:
    'Tidak dapat diubah lagi dalam waktu 30 hari setelah pengaturan',
  setting_successful: 'Pengaturan sukses',
  less_than_30_days_since_last_setting:
    'Kurang dari 30 hari sejak pengaturan terakhir',
  game_buddy_accepts_order: 'Pendamping menerima orderan',
  game_buddy_confirms_completion: 'Pendamping mengkonfirmasi penyelesaian',
  game_buddy_refunds: 'Pengembalian dana untuk pendamping',
  full_refund: 'Pengembalian dana penuh',
  partial_refund: 'Pengembalian dana sebagian',
  game_buddy_rejects_refund: 'Pendamping menolak pengembalian dana',
  refund_successful: 'Pengembalian dana sukses',
  repurchase_rate: 'Tingkat pembelian kembali',
  place_order_now: 'Order sekarang',
  payment_method: 'Cara pembayaran',
  nicee_balance_payment: 'Bayar dengan saldo nicee',
  available: 'koin tersedia',
  add_credit_card_payment: 'Tambahkan pembayaran kartu kredit',
  pay_with: 'Bayar {msg}koin',
  promotion_details: 'Kegiatan gratis',
  limited_to_one_order_cannot_be_combined_with_other_discounts:
    'Terbatas satu orderan, tidak dapat digunakan bersamaan dengan penawaran promosi lainnya',
  currently_msg_available: 'Saat ini {msg} tersedia',
  order_amount_less_than: 'Jumlah orderan belum mencapai',
  new_user_exclusive_discount: 'Diskon eksklusif pendatang baru',
  pay: 'Bayar',
  product_name: 'Nama produk',
  order_amount: 'Jumlah orderan',
  credit_card_debit_card_number: 'Nomor kartu kredit/kartu keuangan',
  proceed_to_payment: 'Pergi ke Pembayaran',
  select_credit_card_debit_card: 'Pilih kartu kredit/kartu keuangan',
  or: 'atau',
  use_another_credit_card_debit_card:
    'Penggunaan kartu kredit/keuangan lainnya',
  automatically_select_randomly_if_expired:
    'Pemilihan acak otomatis jika waktu habis',
  only_visible_to_those_who_meet_the_order_requirements:
    'Hanya mereka yang memenuhi syarat untuk mengambil orderan yang dapat melihatnya',
  delete_pricing: 'Apakah harga itu dihapus?',
  please_set_the_price: 'Silakan tentukan harga',
  create_room: 'Membuat ruangan',
  enter_password: 'Masukkan kata sandi',
  incorrect_password: 'Kesalahan masukan kata sandi',
  room_not_open: 'Ruangan belum dibuka',
  need_password: 'Perlu memasukkan kata sandi',
  overall_ranking: 'Daftar Rangking',
  want_to_delete_this_update: 'Yakin ingin hapus postingan ini?',
  do_not_delete: 'Tidak',
  countdown_prompt:
    'mohon menyelesaikan pemilihannya sebelum waktunya berlalu\n',
  countdown_prompt2: 'dibatalkan karena waktu telah berlalu',
  countdown_prompt3:
    'akan mengakibatkan tidak dapat membuat pesanan pada hari itu juga',
  select_he: 'pilih dia',
  next_time_ok: 'nanti aja',
  take_on_order: 'yakin ingin menerima pesanan ini?',
  order_acceptance_prompt:
    'Memberikan layanan berkualitas tinggi dan mendapatkan ulasan bintang lima yang menarik bisa membantu Anda mendapatkan lebih banyak eksposur dan pesanan! Tolong terjemahkan ke bahasa Indonesia.',
  people: 'orang',
  order_creation_in_progress: 'Pesanan sedang diproses',
  bill: 'Tagihan',
  teacher_now: 'Mulai mengajar',
  teacher_rank: 'Peringkat pengajar',
  tag_hot: 'Populer',
  tag_minutes7: 'Coba baru',
  tag_new: 'Pendatang baru',
  tag_nice: 'Reputasi',
  h5_live_setting_title: 'Pengaturan Live',
  h5_live_detection: 'Deteksi Live',
  h5_live_detection_tip:
    'Saat live, tampilan live akan muncul di status pribadi',
  h5_live_title: 'Judul Live',
  h5_live_title_placeholder: 'Ketuk untuk memasukkan judul live',
  h5_live_url: 'Tautan Live',
  h5_live_url_placeholder: 'Ketuk untuk memasukkan tautan live',
  h5_live_supported_platform: 'Platform yang didukung',
  h5_live_cover: 'Cover Live',
  h5_live_cover_tip: 'Unggah ulang untuk memperbarui cover',
  h5_live_url_required: 'Tautan tidak boleh kosong',
  h5_live_url_invalid: 'Tautan tidak valid',
  h5_live_title_required: 'Judul tidak boleh kosong',
  h5_live_cover_required: 'Cover tidak boleh kosong',
  save_successfully: 'Berhasil disimpan',
  h5_order_comment_feeling_title: 'Bagaimana perasaan Anda tentang pengguna ini?',
  h5_order_comment_anonymous_done: 'Sudah anonim',
  h5_order_comment_choose_reason:
    'Pilih alasan untuk membantu platform menjaga ekosistem yang sehat',
  h5_order_comment_feedback_placeholder:
    'Masukan Anda membantu kami menjadi lebih baik (maks. 200 karakter)',
  h5_order_comment_privacy_tip:
    'Penilaian tidak akan ditampilkan kepada pengguna lain, hanya untuk pengumpulan data',
  h5_order_comment_submit: 'Kirim penilaian',
  h5_order_comment_exit_message:
    'Keluar akan membatalkan penilaian ini. Yakin ingin keluar?',
  h5_order_comment_confirm_exit: 'Konfirmasi keluar',
  h5_month_day: '{day}/{month}',
  h5_gift_total_count: 'Total hadiah',
  h5_gift_wall_empty:
    'Belum menerima hadiah untuk saat ini, tetap semangat ya',
  h5_yomi_empty: 'Belum ada game yang tersedia',
  h5_bind_invitation_code: 'Ikat kode undangan',
  h5_player_list_default_title: 'Zona Mabar',
  h5_new_user_coupon: 'Kupon pengguna baru',
  h5_fans_count: 'Jumlah penggemar',
  h5_full_discount_offer: 'Beli {startNum} gratis {giftNum}',
  h5_recharge_before_send_gift:
    'Silakan top up di halaman top up sebelum mengirim hadiah',
  h5_selected_gift_not_exist: 'Hadiah yang Anda pilih tidak ada',
  h5_gift_rejected: 'Hadiah Anda ditolak',
  h5_balance_not_enough_recharge_first:
    'Saldo Anda tidak cukup, silakan top up dulu',
  h5_gift_send_failed: 'Gagal mengirim hadiah',
  h5_gift_count_1: 'Sepenuh hati',
  h5_gift_count_10: 'Sempurna',
  h5_gift_count_99: 'Selamanya',
  h5_gift_count_188: 'Mau peluk',
  h5_gift_count_520: 'Aku cinta kamu',
  h5_gift_count_1314: 'Seumur hidup',
  h5_gift_snowman_not_enough:
    'Jumlah Snowman Hangat yang Anda miliki tidak cukup. Buka halaman event untuk membeli?',
  h5_gift_bell_need_buy:
    'Anda masih perlu membeli {count} Lonceng Natal. Lanjutkan?',
  h5_gift_deprecated: 'Sudah diturunkan',
  h5_player_detail_chat_before_order_title: 'Chat dulu sebelum memesan',
  h5_player_detail_chat_before_order_text:
    'Chat sebelum memesan membantu memastikan info pendamping',
  h5_player_detail_order_direct: 'Pesan langsung',
  h5_player_detail_go_chat: 'Chat',
  h5_player_detail_no_remind: 'Jangan ingatkan lagi',
  h5_player_detail_tag_explain: 'Penjelasan tag',
  h5_player_detail_tag_rebought: 'Repeat Order Tinggi',
  h5_player_detail_tag_rebought_desc:
    'Top 20 rata-rata repeat order per orang (90 hari terakhir)',
  h5_player_detail_tag_nice: 'Reputasi bagus',
  h5_player_detail_tag_nice_desc: 'Terpilih masuk rekomendasi ulasan beranda',
  h5_player_detail_tag_hot: 'Populer',
  h5_player_detail_tag_hot_desc: 'Sering menerima order',
  h5_player_detail_tag_new: 'Pendatang baru unggulan',
  h5_player_detail_tag_new_desc:
    'Pendamping berkualitas yang baru bergabung belakangan ini',
  h5_player_detail_tag_position: 'Posisi terverifikasi',
  h5_player_detail_tag_position_desc: 'Performa posisi ini sangat baik',
  h5_guardian_gift_reach: 'Kirim hadiah hingga',
  h5_guardian_can_be_guardian: 'untuk menjadi pelindung',
  h5_guardian_need_more_to_be_guardian:
    'Anda masih perlu {count}💎 untuk menjadi pelindung',
  h5_list_separator: ', ',
  h5_player_detail_comment_player_reply: 'Balasan pendamping',
  h5_player_detail_comment_empty_self:
    'Belum ada yang memberi Anda ulasan untuk saat ini',
  h5_player_detail_comment_empty_other:
    'Belum ada yang memberi dia ulasan untuk saat ini',
  h5_player_detail_comment_reply_placeholder: 'Tulis balasan...',
  h5_player_detail_comment_reply_confirm:
    'Anda hanya punya satu kesempatan membalas ulasan. Setelah dikirim tidak bisa diubah.',
  h5_player_detail_comment_hidden_default:
    '-{count} ulasan baik default telah disembunyikan-',
  h5_gift_icon_title: 'Apa itu medali hadiah?',
  h5_gift_icon_desc1:
    'Medali hadiah adalah medali yang diperoleh pengguna nicee dengan mengirim hadiah',
  h5_gift_icon_desc2:
    'Medali ini akan ditampilkan setelah nama di komentar, layar publik voice room, dan kartu profil',
  h5_gift_icon_rule_title: 'Aturan pemberian:',
  h5_gift_icon_rule_time: '- Medali hadiah dihitung dan diberikan setiap hari pukul 06.00',
  h5_gift_icon_level1_line1:
    'Total hadiah di platform dalam 30 hari terakhir minimal NTD 500, ',
  h5_gift_icon_level1_line2: 'dan kurang dari NTD 1000 untuk mendapatkannya',
  h5_gift_icon_level2_line1:
    'Total hadiah di platform dalam 30 hari terakhir minimal NTD 1000, ',
  h5_gift_icon_level2_line2: 'dan kurang dari NTD 2500 untuk mendapatkannya',
  h5_gift_icon_level3_line1:
    'Total hadiah di platform dalam 30 hari terakhir minimal NTD 2500',
  h5_gift_icon_level3_line2: 'untuk mendapatkannya',
  h5_limited_time: 'Terbatas',
  h5_player_list_super_cheap: 'Super murah',
  h5_player_list_newbie: 'Pemula baru',
  h5_refund_no_reply_auto_refund:
    'Jika pendamping tidak membalas dalam 24 jam, pengembalian dana akan otomatis berlaku dan dana kembali ke akun Anda',
  h5_refund_negotiate_tip:
    'Jika nominal bermasalah, Anda dapat berdiskusi lebih lanjut dengan pendamping dan meminta pendamping mengembalikan dana. Jika tidak mencapai kesepakatan, Anda dapat meminta bantuan customer service. Jika tidak diproses, order akan otomatis selesai setelah 7 hari.',
  h5_refund_reason_completed: 'Layanan sudah selesai',
  h5_refund_reason_malicious: 'Pengguna mengajukan refund dengan niat buruk',
  h5_request_error: 'Permintaan gagal!',
  h5_minutes_ago: '{msg} menit lalu',
  h5_hours_ago: '{msg} jam lalu',
  h5_days_ago: '{msg} hari lalu',
  h5_relegation_privilege_title:
    'Apa itu Privilege Pertahankan Level dan bagaimana mendapatkannya?',
  h5_relegation_privilege_desc:
    'Saat mengambil hadiah level, jika menggunakan "Privilege Pertahankan Level", poin level tidak akan dikurangi. Jika mencapai level Legend 3 kali berturut-turut (VIP13 ke atas) tanpa menggunakan privilege ini, Anda bisa mendapatkan 1 kesempatan tambahan. Privilege ini dapat dikumpulkan maksimal 2 kali.',
  h5_relegation_privilege_current:
    'Privilege Pertahankan Level yang Anda miliki saat ini: {count} kali',
  h5_relegation_privilege_continuous:
    'Jumlah berturut-turut mencapai Legend saat ini: {count} kali',
  h5_relegation_privilege_max:
    'Jumlah privilege sudah mencapai batas maksimum',
  h5_relegation_privilege_note:
    'Catatan: Setelah menggunakan Privilege Pertahankan Level, jumlah berturut-turut mencapai Legend akan dihitung ulang.',
  h5_relegation_privilege_example1:
    'Jika level Anda mencapai VIP13 ke atas saat perhitungan tanggal 1 selama 3 bulan berturut-turut: ',
  h5_relegation_privilege_example2:
    'Pada tanggal 1 bulan pertama dan kedua, jumlah berturut-turut mencapai Legend akan tampil masing-masing: 1 dan 2; ',
  h5_relegation_privilege_example3:
    'Pada bulan ketiga, jumlah berturut-turut akan tampil 0, dan jumlah "Privilege Pertahankan Level" bertambah 1. ',
  h5_relegation_privilege_example4:
    'Namun jika Anda menggunakan "Privilege Pertahankan Level" pada bulan kedua, jumlah berturut-turut mencapai Legend akan langsung berubah dari 2 menjadi 0, dan pada tanggal 1 bulan ketiga jumlah berturut-turut tetap 0.',
  other: 'Lainnya',
  h5_customer_long_time_no_see: 'Lama tidak bertemu',
  h5_customer_old_tip:
    '{total} orang sudah lama tidak memesan dari Anda. Sapa mereka yuk',
  h5_customer_interaction_history: 'Riwayat interaksi',
  h5_customer_chat_with: 'Chat dengan {pronoun}',
  h5_customer_new_done:
    'Semua pengguna baru yang perlu dijaga sudah selesai',
  h5_customer_old_empty:
    'Di sini ditampilkan pelanggan yang memesan dari Anda dalam 7-30 hari terakhir. Saat teman lama muncul, jangan lupa menyapa ya',
  h5_customer_greeting_1: 'Halo~ Kalau mau main, ajak saya ya!',
  h5_customer_greeting_2: 'Halo bos~ Mau main game?',
  h5_customer_greeting_3: 'Kamu datang~ Aku sudah lama menunggu > <',
  h5_customer_edit_message: 'Edit konten yang akan dikirim',
  h5_customer_custom: 'Kustom',
  h5_customer_send: 'Kirim',
  h5_customer_send_success: 'Berhasil dikirim',
  h5_customer_input_placeholder: 'Ketuk untuk memasukkan...',
  h5_customer_group_send: 'Kirim massal',
  h5_customer_once_per_day: 'Satu kesempatan per hari',
  h5_customer_order_summary_prefix: 'Sudah memesan ',
  h5_customer_order_summary_middle: ' order, total nilai ',
  h5_customer_order_summary_suffix: ' koin,',
  h5_customer_order_history: 'Riwayat order',
  h5_customer_order_history_item_prefix:
    '{pronoun} memesan ',
  h5_customer_order_history_item_middle:
    ' dari Anda sebanyak {count} order, jumlah order ',
  h5_player_topic_recommend_reason: 'Alasan rekomendasi: ',
  h5_income_withdraw: 'Tarik',
  h5_income_order_no: 'Order: {orderNo}',
  h5_income_balance: 'Saldo: {amount}',
  h5_income_repurchase_subsidy: 'Termasuk subsidi repeat order +{amount}',
  h5_income_order_no_copied: 'Nomor order berhasil disalin',
  h5_income_revenue: 'Pemasukan',
  h5_income_expense: 'Pengeluaran',
  h5_income_select_year_month: 'Pilih tahun dan bulan',
  h5_income_all_time: 'Semua waktu',
  h5_income_year_month: '{month}/{year}',
  h5_income_settlement_note:
    'Penyelesaian order normal akan selesai dalam 7 hari kerja',
  h5_diamond_start_exchange: 'Mulai tukar',
  h5_vip_member_outfit_permanent: 'Dekorasi eksklusif member (permanen)',
  h5_vip_member_outfit_remark:
    'Bingkai avatar eksklusif level, gelembung chat, dan banner masuk',
  h5_vip_coupon_title: '{count} kupon diskon {amount} koin',
  h5_vip_monthly_claim_all:
    'Dapat diklaim setelah tanggal 1 setiap bulan (berlaku untuk semua)',
  h5_vip_need_points: 'Perlu poin member {points}',
  h5_vip_diamond_title: '{amount} diamond',
  h5_vip_monthly_claim: 'Dapat diklaim setelah tanggal 1 setiap bulan',
  h5_vip_avatar_frame: 'Bingkai avatar "{name}" (permanen)',
  h5_vip_mount: 'Mount "{name}"',
  h5_vip_mount_permanent: 'Mount "{name}" (permanen)',
  h5_vip_voice_room_enter: 'Tampil sebagai identitas saat masuk voice room',
  h5_vip_voice_room_noble_enter:
    'Tampil sebagai identitas mulia saat masuk voice room',
  h5_vip_unlock_level_gift: 'Buka hadiah eksklusif level "{name}"',
  h5_vip_level_gift: 'Hadiah eksklusif level "{name}"',
  h5_vip_home_recommend_hours:
    'Penerima hadiah mendapat rekomendasi beranda {hours} jam',
  h5_vip_app_cover_hours: 'Penerima hadiah tampil di cover APP {hours} jam',
  h5_vip_exclusive_frame: 'Bingkai avatar eksklusif "{name}" (permanen)',
  h5_vip_gift_both_get:
    'Setelah mengirim hadiah "{name}", pengirim dan penerima dapat memperolehnya',
  h5_vip_beautiful_id: 'ID cantik {digits} digit',
  h5_vip_permanent_custom_frame:
    '1 bingkai avatar eksklusif pilihan permanen',
  h5_vip_item_qili_fire: 'Kembang Api Indah',
  h5_vip_item_bright_stars: 'Bintang Gemerlap',
  h5_vip_item_dream_car: 'Mobil Impian',
  h5_vip_item_white_tiger: 'Harimau Putih',
  h5_vip_item_extreme_car: 'Mobil Ekstrem',
  h5_vip_item_romantic_firework: 'Kembang Api Romantis',
  h5_vip_item_qilin: 'Qilin',
  h5_vip_item_moved_for_you: 'Tergerak Untukmu',
  h5_vip_item_crystal_shine: 'Kilau Kristal',
  h5_vip_item_pyramid: 'Piramida',
  h5_vip_item_legend: 'Legenda',
  h5_vip_item_phoenix: 'Phoenix',
  h5_vip_item_sky_city: 'Kota di Langit',
  h5_vip_item_legend_phoenix: 'Phoenix Legendaris',
  h5_vip_item_king_legend: 'Raja Legenda',
  h5_vip_item_dragon: 'Naga',
  h5_vip_item_legend_throne: 'Singgasana Legenda',
  h5_vip_item_legend_dragon: 'Naga Legendaris',
  h5_vip_item_eternal_legend: 'Legenda Abadi',
  h5_vip_item_manifest_world: 'Hadir di Dunia',
  h5_vip_item_nirvana: 'Nirwana',
  speak_now_rank_rule: 'Peringkat berdasarkan poin hadiah tiga hari terakhir. Hadiah di ruang obrolan mendapat 5x poin.', speak_now_confess: 'Ungkapkan perasaan', speak_now_select_target: 'Pilih orang yang ingin kamu tuju', speak_now_search_placeholder: 'Masukkan nama panggilan atau ID', speak_now_visit_profile: 'Lihat profil', speak_now_recent_gifters: 'Orang yang baru-baru ini kamu kirimi hadiah', speak_now_create_title: 'Kepada siapa kamu ingin mengungkapkan perasaan?', speak_now_select_confession_target: 'Pilih tujuan', speak_now_content_placeholder: 'Masukkan isi ungkapanmu', speak_now_score: 'Nilai kedekatan: {score}', speak_now_score_too_low: 'Nilai kedekatan terlalu rendah?', speak_now_send_more_gifts: 'Kirim lebih banyak hadiah', speak_now_select_target_error: 'Silakan pilih tujuan.', speak_now_content_error: 'Silakan masukkan isi ungkapanmu.', speak_now_success: 'Berhasil dikirim!',
  newcomer_zone_title: 'Pendatang Baru', newcomer_zone_subtitle: 'Temui pendamping terbaru kami', newcomer_zone_latest: 'Posting terbaru', coupon_invitation_title: 'Masukkan kode undangan', coupon_invitation_placeholder: 'Masukkan kode undangan', coupon_invitation_invalid: 'Kode undangan salah. Periksa dan coba lagi.', coupon_phone_invalid: 'Nomor telepon kosong atau bukan nomor Taiwan.', coupon_bind_failed: 'Gagal menghubungkan',
  apullc_hero: 'Ajak teman dan dapatkan 3% dari top up mereka', apullc_reward_summary_1: 'Dapatkan 3% hadiah top up dan bingkai avatar eksklusif', apullc_reward_summary_2: 'Teman mendapat kupon uji coba gratis dan kupon senilai 100 koin', apullc_detailed_rules: 'Aturan lengkap', apullc_rules: 'Saat teman mendaftar dengan kode undanganmu, kamu mendapat 3% dari setiap top up mereka selama 60 hari (maksimal perhitungan 30.000 per top up). Undang 15 teman untuk mendapat bingkai avatar permanen. Teman baru mendapat kupon 50 koin dan paket kupon senilai 100 koin.', apullc_link_copied: 'Tautan undangan disalin', apullc_share_link: 'Atau bagikan tautan undangan', apullc_my_records: 'Riwayat aktivitasku', apullc_total_invited: 'Total pengguna yang diundang', apullc_cashback_total: 'Total cashback top up', apullc_points_total: 'Total poin anggota', apullc_limited_frame: 'Bingkai avatar eksklusif', apullc_frame_name: 'Cyber Rebel', obtained: 'Sudah didapat', apullc_recent_rewards: 'Hadiah terbaru', apullc_no_records: 'Belum ada riwayat. Ajak temanmu sekarang!', apullc_bind_code: 'Hubungkan kode undangan', claim: 'Klaim', apullc_notes: 'Hadiah undangan memerlukan waktu pemrosesan. Hanya akun dengan nomor Taiwan yang dianggap sebagai pengguna undangan yang valid. Pendaftaran berulang tidak valid. Hubungi layanan pelanggan jika ada pertanyaan.', apullc_share_message: 'Bergabunglah denganku di Nicee dan temukan teman bermain! Daftar melalui tautan undanganku untuk mendapat satu pesanan gratis dan paket kupon.', apullc_clipboard_denied: 'Izin papan klip ditolak', apullc_got_frame: 'Mendapat bingkai avatar Cyber Rebel', apullc_recharge_reward: '{user} melakukan top up dan mendapat {amount} koin',
  apullc_claim_offer_title: 'Klaim penawaran eksklusif!', apullc_kol_offer: 'Satu pesanan gratis dan paket kupon senilai 250 koin', apullc_standard_offer: 'Satu pesanan gratis dan paket kupon senilai 100 koin', apullc_bind_phone: 'Silakan hubungkan nomor telepon', phone_number: 'Nomor telepon', sending: 'Mengirim', apullc_resend_countdown: 'Kirim ulang ({seconds})', apullc_get_code: 'Dapatkan kode verifikasi', verification_code: 'Kode verifikasi', invitation_code: 'Kode undangan', claim_offer: 'Klaim penawaran', nicee_platform_tagline: 'Platform teman bermain berkualitas', enter_phone_number: 'Masukkan nomor telepon', phone_number_format_error: 'Format nomor telepon salah', enter_valid_phone_number: 'Masukkan nomor telepon yang valid', enter_invitation_code: 'Masukkan kode undangan', verification_code_error: 'Kode verifikasi salah', apullc_success_reward: 'Selamat! Kamu mendapat hadiah referral.', apullc_success_login: 'Masuk ke Nicee dengan nomor telepon untuk menggunakan penawaran.', apullc_google_play_opened: 'Membuka Google Play', apullc_google_play_fallback: 'Google Play tidak tersedia. APK akan diunduh langsung.',
  view_full_image: 'Lihat gambar penuh', updating: 'Memperbarui', retry: 'Coba lagi', generating: 'Membuat...', loading: 'Memuat', vocality_voice_intro: 'Perkenalan suara', vocality_record_sample: 'Rekam sampel suara', vocality_recommended_duration: 'Disarankan: 7–10 detik', vocality_record_description: 'Rekam suara yang jelas selama 7–10 detik untuk membuat kartu profil suara.', vocality_recording_tips: 'Tips perekaman', vocality_tip_duration: 'Durasi yang disarankan: 7–10 detik', vocality_tip_clarity: 'Bicara dengan jelas dan tempo sedang', vocality_tip_noise: 'Hindari kebisingan latar', vocality_card_preview: 'Pratinjau kartu profil suara', vocality_generating_official: 'Membuat kartu profil suara resmi...', vocality_loading_existing: 'Memuat kartu profil suara yang ada...', vocality_update_name: 'Perbarui nama', vocality_profit_calculation: 'Perhitungan penghasilan', vocality_reused: 'Digunakan kembali', vocality_generated: 'Sudah dibuat', vocality_image_error: 'Gambar bermasalah', vocality_regenerate_required: 'Perlu dibuat ulang', vocality_pending: 'Menunggu', vocality_record_intro_first: 'Rekam perkenalan suara terlebih dahulu', vocality_record_sample_first: 'Rekam sampel suara terlebih dahulu', vocality_regenerate_card: 'Buat ulang kartu profil suara', vocality_generate_card: 'Buat kartu profil suara', vocality_existing_image_missing: 'Kartu yang ada tidak memiliki gambar resmi. Rekam ulang dan buat kartu sebelum mengirim.', vocality_loading_wait: 'Sedang memuat kartu. Harap tunggu.', vocality_login_to_generate: 'Masuk terlebih dahulu untuk membuat kartu', vocality_generating_wait: 'Kartu sedang dibuat. Harap tunggu.', vocality_generate_failed: 'Gagal membuat kartu profil suara', vocality_image_generate_failed: 'Gagal membuat gambar kartu. Coba lagi nanti.', vocality_generate_success: 'Kartu profil suara berhasil dibuat', vocality_generate_retry: 'Gagal membuat kartu. Coba lagi nanti.', vocality_data_error: 'Data kartu tidak valid. Silakan buat ulang.', vocality_enter_nickname: 'Masukkan nama panggilan terlebih dahulu', vocality_login_to_update: 'Masuk terlebih dahulu untuk memperbarui', vocality_name_update_failed: 'Gagal memperbarui nama kartu', vocality_image_update_failed: 'Gagal memperbarui gambar kartu. Coba lagi nanti.', vocality_name_updated: 'Nama kartu diperbarui', vocality_name_update_retry: 'Gagal memperbarui nama kartu. Coba lagi nanti.', vocality_image_missing: 'Kartu tidak memiliki gambar resmi. Rekam ulang dan buat kartu sebelum mengirim.', vocality_image_load_failed: 'Gagal memuat gambar resmi. Coba lagi atau rekam ulang untuk membuat kartu.', vocality_generate_first: 'Buat kartu profil suara resmi terlebih dahulu', select_level_first: 'Pilih level terlebih dahulu', enter_self_introduction: 'Masukkan perkenalan diri'
  ,apullc_rules_exact: 'Jika teman mendaftar menggunakan kode undangan di bawah, saya akan menerima hadiah sebesar 3% dari setiap top up yang mereka lakukan dalam 60 hari. Jika satu kali top up melebihi 30.000, hadiah dihitung berdasarkan 30.000. Untuk setiap pengguna baru yang memenuhi syarat dan berhasil diundang, pengundang mendapatkan 1.500 poin keanggotaan. Setelah berhasil mengundang 15 pengguna untuk mendaftar, saya akan menerima bingkai avatar eksklusif acara Cyber Rebel secara permanen. Saat teman mendaftar, mereka akan menerima satu kupon 50 koin tanpa minimum belanja dan paket kupon bertingkat dengan nilai total 100 koin.', apullc_notes_exact: 'Hadiah undangan memerlukan waktu pemrosesan. Harap tunggu dengan sabar. Hanya akun yang terhubung ke nomor telepon Taiwan yang dianggap sebagai pengguna undangan yang valid. Undangan dari pendaftaran berulang pada perangkat yang sama atau dengan cara lain tidak valid. Jika ada pertanyaan, silakan hubungi layanan pelanggan.', search: 'Cari', request_failed: 'Permintaan gagal', network_error: 'Gangguan jaringan', vocality_audio_read_failed: 'Gagal membaca rekaman. Silakan rekam ulang.', vocality_reject_not_human: 'Suara manusia yang jelas tidak terdeteksi. Silakan rekam ulang.', vocality_reject_too_short: 'Sampel suara terlalu pendek. Rekam setidaknya 8 detik.', vocality_reject_too_noisy: 'Sampel terlalu berisik. Rekam ulang di tempat yang tenang.', vocality_reject_tts: 'Suara sintetis terdeteksi. Gunakan suara asli kamu.', vocality_reject_default: 'Sampel suara tidak lolos verifikasi. Silakan rekam ulang.'
  ,jkoPay: {
    name: 'JKOPAY', retry: 'Periksa pembayaran lagi', resultPending: 'Pembayaran menunggu konfirmasi',
    success: 'Pembayaran berhasil', unconfirmed: 'Pembayaran belum dikonfirmasi', queryFailed: 'Tidak dapat memeriksa pembayaran',
    processing: 'Mengonfirmasi pembayaran', credited: '{asset} telah masuk.',
    genericPending: 'Permintaan isi ulang telah dikirim. Konfirmasi bank biasanya memerlukan 1–5 menit.',
    unconfirmedDescription: 'Pembayaran JKOPAY belum terkonfirmasi. Coba lagi nanti dan jangan membayar dua kali.',
    queryFailedDescription: 'Hasil JKOPAY tidak dapat diperiksa saat ini. Coba lagi nanti dan jangan membayar dua kali.',
    processingDescription: 'Sedang mengonfirmasi pembayaran dengan JKOPAY. Jangan membayar dua kali.',
    nicee: 'Koin Nicee', diamond: 'Berlian'
  }
};
export default idn;
